export default {
  cn: {
    text: {
      fileName: '文件名称',
      doing: '加载中',
      sysError: '系统错误',
      view: '查看',
      list: '列表',
      count: '统计',
      action: '动作',
      create: '新增',
      createCustom: '定制',
      createCustom2: '样衣',
      createBulk: '大货',
      createQuick: '快捷',
      edit: '编辑',
      delete: '删除',
      remove: '移除',
      close: '关闭',
      submit: '提交',
      save: '保存',
      back: '返回',
      register: '免费注册',
      login: '登  录',
      returnLogin: '返回登录',
      noimage: '无图片',
      noimageMini: '无',
      baseInfo: '基本信息',
      name: '名称',
      more: '更多',
      noData: '暂无数据',
      asyncInv: '是否同步库存',
      sequence: '排序',
      seq: '序号',
      explain: '说明',
      reference: '变量',
      template: '模版',
      qrCode: '二维码',
      perfectInformation: '完善公司信息',
      createAt: '创建日期',
      workflowState: '状态',
      remark: '备注',
      batchRemark: '批量备注',
      quantity: '数量',
      special: '特殊',
      owner: '所属',
      ownerName: '所属人',
      time: '时间',
      date: '日期',
      handle: '经办',
      handOverAt: '交货日期',
      handOverAt2: '交期',
      handOverAtDateMinus: '距交期',
      printAt: '打印日期',
      flag: '旗帜',
      content: '内容',
      serialNo: '单号',
      log: '日志',
      unPrint: '未打印',
      stop: '停',
      paused: '停',
      startAt: '开始日期',
      endAt: '结束日期',
      startTimeAt: '开始时间',
      endTimeAt: '结束时间',
      type: '类型',
      total: '合计',
      detail: '详细',
      lineItem: '明细',
      settlementLineItem: '账单明细',
      qrcode: '二维码',
      printInfo: '打印情况',
      month: '月',
      edition: '版本',
      orderType: '订单类型',
      search: '查询',
      number: '数字',
    },
    printInfos: {
      yes: '已打印',
      no: '未打印',
    },
    sysMesTypes: {
      all: '全部',
      onlyZero: '仅价格为0的',
    },

    rules: {
      required: '请输入{0}',
      select: '请选择{0}',
      selected: '已选择过该{0}',
      error: '{0}错误',
      exist: '{0}存在',
      repect: '{0}重复',
      mixed: '该{0}已配过',
      shared: '{0}已共享',
      filledIn: '已填写过该{0}',
      regex: '请输入正确的{0}',
      mustFillSimple: '*{0}',
      mustFill: '{0} 必填',
      startAt: '{0}开始',
      endAt: '{0}结束',
      create: '新增{0}',
      edit: '编辑{0}',
      beyondMaxQty: '数量大于最大数量：{0}',
      // quantityJudge: '数量应大于0小于{0}',
      productNoNoXX: '该货号下没有{0}',
      min: '{0}-最小',
      max: '{0}-最大',
      buttJoint: '和{0}对接',
      pagerTotal: '共 {0} 条记录',
    },
    menu: {
      profile: '我的信息',
      company: '公司信息',
      logout: '退出',
      perferences: '设置',
      users: '子账户',
      shops: '店铺',
      warehouses: '仓库',
      shelfs: '库位',
      categories: '分类',
      sizes: '规格',
      units: '单位',
      colors: '颜色',
      attributes: '自定义属性',
      labels: '标签',
      brands: '品牌',
      tagTemplates: '吊牌模版',
      craftworkTemplates: '制作工艺模版',
      currencies: '币种',
      groups: '订单分组',
      customerGroups: '客户分组',
      bargainTemplates: '销售订单模版',
      remarkTemplates: '订单备注模版',
      payMethods: '收付款方式',
      subjects: '物料科目',
      warehousesMms: '物料仓',
      phaseGroups: '工序分组',
      phases: '工序',
      reworkTypes: '返工类型',
      workers: '工人',
      factories: '产线',
      phaseTemplates: '工序模版',
      workOrderTemplates: '生产单模版',
      stockInTypes: '入库类型',
      stockOutTypes: '出库类型',
      expresses: '国内快递',
      couriers: '国际快递',
      rentTemplates: '租赁单模版',
      scheduleTypes: '日程类型',
      settings: '系统设置',
      downloads: '文件下载',
      notices: '系统消息',
      noticesReceived: '收到的消息',
      noticesSend: '发出的消息',
      products: '产品',
      suppliers: '供应商',
      customers: '客户',
      supplierProducts: '供应商产品',
      quotations: '我的共享',
      inquiriesMy: '我的询价',
      inquiriesCustomer: '客户询价',
      subjects: '科目',
      inventories: '库存',
      cashs: '超发余料',
      stockIns: '入库单',
      stockOuts: '出库单',
      allocates: '调拨单',
      damages: '报损单',
      snapshoots: '库存结存',
      bargains: '销售单',
      orders: '订单项',
      customers2: '客户档案',
      balanceRecords: '充值记录',
      scoreRecords: '积分记录',

      purchases: '外采单',
      pengings: '待处理',
      holdings: '处理中',
      preparings: '备货中',
      processings: '生产中',
      purchasings: '外采中',
      pendingReceives: '待收货',
      unDeliveryPurchases: '供应商未发货',
      unQaWorkerOrders: '工厂未生产完成',
      workOrders: '工单',
      pengingQas: '待质检',
      replenishs: '备货单',
      reminders: '我的催单',
      pendingDeliveries: '待发货',
      requestDeliveries: '申请待发货',
      deliveries: '发货单',
      pickShelfs: '待出库',
      pushShelfs: '待入库',
      pickLists: '拣货清单',
      reworks: '返工单',
      returnBacks: '退货单',
      schedules: '日程管理',
      rents: '租赁单',
      cleans: '清洗单',
      saleOrders: '销售单',
      salesTargets: '销售目标',
      deliveryRequisition: '发货申请单',
      customerSettlements: '客户账单',
      supplierSettlements: '外采账单',
      agentSettlements: '货代账单',
      expressSettlements: '快递账单',
      carrySettlements: '送货账单',
      agentChecks: '货代对帐',
      factorySettlements: '生产账单',
      materialSettlements: '物料账单',
      workerSalaries: '工资单',
      saleSettlements: '业绩结算',
      authTemplates: '权限模版',
      //
      cusromerReturns: '客户退货',
      customerReworks: '客户返工',
      customerReminders: '客户催单',
      orderCancelPendingDeals: '订单取消/退货后续待处理',
      myReworks: '我的返工',
      synchronizeEditions: '订单修改同步外采',
      hangs: '挂单',
      returnFactoryReworks: '退厂返工',
      phaseReworks: '工序返工',
      purchaseChanges: '客户编辑价格待审核',
      //
      mesOrders: '生产订单',
      pendingDispatchs: '待派单',
      pendingQas: '待尾查',
      manufactures: '生产记录',
      tracksOrder: '订单跟单',
      tracksWorkOrder: '工单跟单',
      tracksWorker: '工人跟单',
      //
      materials: '物料',
      procures: '采购单',
      putins: '待入库',
      pendingRequisitions: '待发料',
      requisitions: '发料单',
      calculates: '用料核算',
      lackStatistics: '缺料统计',
      returns: '退料单',
      adapters: '平台对接',
      platforms: '平台',
      requestResponses: '发货反馈',
      sysLogs: '更新日志',
      reports: '报表',
      //
      serials: '系列',
      relateProcures: '相关物料采购单',
      relateOrders: '相关订单',
      relatePurchases: '相关外采单',
      applyTrackings: '申请运单号',
    },
    login: {
      accountLogin: '账号登录',
      vfcodeLogin: '验证码登录',
    },
    editionRegisters: {
      // af: '接单版，我用来接客户下单',
      // bf: '下单版，我用来给供应商下单'
      af: '接单版，接客户下单',
      bf: '下单版，给供应商下单',
    },
    boolean: {
      true: '是',
      false: '否',
    },
    user: {
      account: '账号',
      password: '密码',
      phone: '手机号',
      vfcode: '验证码',
      name: '姓名',
      admin: '管理员',
      checkPassword: '确认密码',
      shop: '所属店铺',
      voidInfo: '失效情况',
      authorize: '授权情况',
      token: '令牌',
    },
    authorizes: {
      authorized: '已授权',
      unAuthorize: '未授权',
      void: '失效',
      noVoid: '未失效',
      admin: '管理员',
    },
    tenant: {
      name: '公司名称',
      industry: '所在行业',
      country: '国家/地区',
      province: '省份',
      city: '城市',
      address: '地址',
      identifier: '公司编号',
      logo: 'LOGO',
      introduction: '公司介绍',
      acceptName: '接单名称',
      placeName: '下单名称',
      expirationAt: '系统到期',
      mainProducts: '主营产品',
      scoreRate: '积分兑换比',
      scoreRatePrompt: '如消费1000元1分，此处写1000',
    },
    shop: {
      isInventory: '同时为仓库',
      deletePrompt: '是否同时删除库存和出入库记录',
      iossNum: 'IOSS号',
      iossCountryCode: 'IOSS注册地',
    },
    category: {
      showShop: '赢小店展示',
      key: 'Key',
      hsCode: '海关编码',
      goodsName: '中文品名',
      goodsNameEn: '英文品名',
      weight: '重量',
      firstUnit: '第一法定单位',
      secondUnit: '第二法定单位',
      declareInfo: '申报要素',
      insured: '保价额',
    },
    color: {
      image: '图片',
    },
    currency: {
      code: '国际标准码',
      symbol: '货币符号',
      cnyRate: '对人民币汇率',
      rate: '汇率',
      display: '是否显示',
      statistic: '统计货币',
    },
    worker: {
      name: '姓名',
      serialNo: '工号',
      token: '令牌',
      phases: '负责工序',
      factories: '所属产线',
      phone: '电话',
      entryAt: '入职时间',
    },
    factory: {
      xcxViewImages: '查看图片',
      xcxViewPhasePrice: '查看工时价',
      user: '用户',
      phaseAndPrice: '工序工价',
      phasePrice: '工时价',
      setPhasePrice: '设置产线工时价',

      bulkCapacity: '大货产能',
      customCapacity: '定制产能',
      redundancyPercent: '冗余产能',
      yearHoliday: '年度休假',
      monthHoliday: '月度休假',
      weekHoliday: '每周休假',
      nonWork: '休假日',
      //
      bulkTotal: '大货总产能',
      bulkUsed: '大货已占用产能',
      bulkRemain: '大货剩余产能',
      customTotal: '定制总产能',
      customUsed: '定制已占用产能',
      customRemain: '定制剩余产能',
    },
    phaseTemplate: {
      phaseHour: '工时(小时)',
      period: '制作周期(天)',
      inspect: '半检',
    },
    express: {
      printFaceSheet: '打印面单',
      payType: '付款类型',
      customerName: '客户号',
      customerPwd: '密码',
      monthCode: '月结号',
      sendSite: '发货网点',
      sendStaff: '收件快递员',
      cainiaoDelivery: '菜鸟物流',
      // cainiaoTemplateUrl: '菜鸟模版'
      //   // logisticCode: '快递单号',
    },
    expressPayTypes: {
      1: '现付',
      2: '到付',
      3: '月结',
      4: '第三方支付',
    },
    courier: {
      courierAccount: '货代公司账号',
      login: '账户',
      password: '密码',
      contact: '联系人',
      phone: '电话',
      erp: '货代erp名称',
      erpKey: '账号(APP KEY)',
      erpPassword: '密码',
      code: '渠道代码',
      description: '渠道说明',
      channel: '渠道',
      economyService: '经济',
      standardService: '标准',
      premiumService: '优先',
      warehouse_name: '服务仓',
      logistics_service_name: '服务名称',
      delivery_address: '仓库地址',
      //邮政
      erpPassword: '密钥(APP SECRET)',
      mailType: 'erp标识',
      whCode: '揽收机构号',
      account: '分账号',
      accountSF: '月结账号',
      aeskey: 'AES KEY',
      apiusername: '顺丰用户名',
      accountNumber: '账号',
      tradeName: '经营单位',
      tradeCoScc: '社会信用代码',
      tradeCode: '海关注册编号',

      erpKeyDhl: 'USUER NAME',
      erpPasswordDhl: 'PASSWORD',
      consumerCodeDhl: 'consumerCode',
      keyDhl: 'key',
      crCodeDhl: '海关注册编码',
      businessNumberDhl: '营业执照注册编码',
      businessNameDhl: '公司名称',
      signNameDhl: '姓名',
      signImageDhl: '电子签名',
      carrierCode: '承运人',
      carrierMethod: '承运方式',
      lianbangSignImage: '发货人签名',
      lianbangLetterHead: '公司抬头',
      JituErpKey: 'eccompanyid',
      JituErpPassword: 'key',
      JituAccount: 'customerid',
    },

    config: {
      nearDays: '近交期(天)',
      dealType: '订单处理方式',
      publishMessage: '公开我公司信息到产业联盟,让别人能找到我',
      loginNotify: '异地登录通知',
      financeVerifyStrict: '订单审核强介入（审核后订单才能走流程处理）',
      deliveryStrict: '欠款发货需审核',
      autoAsyncPurchase: '订单修改，自动同步外采单及供应商相关订单',
      outgoingQualityControl: '现货出货质检',
      createOrderFixShop: '录单只能录自己所属店铺',
      invNeedPickPush: '订单收货质检、发货后手动入库、出库',
      mmsInvUseCash: '物料发料时候多发料进库存余量',
      mesSchedule: '启用生产排程功能',
      bargainForceBalance: '录订单强制用账户余额付款',
      bulkOrder:
        '大货订单管理模式(1、设置后销售单以订单列表展示 2、只能以大货模式录单 3、带发货页面以订单项形式展示，且只能标记发货)',
    },

    dealTypes: {
      available: '现货',
      manufacture: '生产',
      purchase: '外采',
    },

    download: {
      downloadInfo: '下载情况',
      downloaded: '已下载',
      unDownload: '未下载',
      downloadAt: '下载日期',
    },
    downloadFileStates: {
      downloading: '生成中',
      finish: '已生成',
      uploadError: '失败', //'上传失败',
      generateError: '失败', //'生成失败',
      fileNotFound: '失败', //'生成失败',
    },
    notice: {
      content: '内容',
      sendAt: '发送日期',
      sender: '发送人',
      readAt: '阅读时间',
      receiver: '接收人',
      serialNo: '相关单号',
      readInfo: '阅读情况',
      readed: '已读',
      unRead: '未读',
      readBatch: '全部已读',
      history: '消息历史',
    },
    noticeTypes: {
      purchaseReject: '外采单拒绝',
      orderRemind: '订单催办',
      orderHurry: '订单加急',
      orderEdit: '订单修改',
      orderRetrieve: '订单被撤单',
      purchaseRemind: '外采单催单',
      purchaseEdit: '外采单编辑',
      orderReject: '订单拒绝',
      sys: '系统通知',
      sup2CusMes: '手动发送',
      cus2SupMes: '手动发送',
      recevieGood: '退货已收',
    },
    payMethodTypes: {
      sale: '销售',
      balance: '充值',
      both: '销售、充值',
    },
    rechargeScoreTypes: {
      in: '充值',
      out: '扣减',
    },
    product: {
      productNo: '货号',
      productNoAlias: '货号别名',
      alias: '别名',
      category: '分类',
      unit: '单位',
      purchaseUrl: '外采链接',
      label: '标签',
      color: '颜色',
      size: '规格',
      images: '图片',
      introduction: '描述',
      craftwork: '制作工艺',
      tag: '吊牌',
      showShop: '赢小店展示',
      brand: '品牌',
      price: '价格',
      salesPrice: '售价',
      costPrice: '成本价',
      cost: '成本',
      wholeSalePrice: '批发价',
      productCostPrice: '产品成本价',
      sizePrice: '规格价',
      sizeQty: '规格用量',
      phase: '工序',
      material: '物料',
      materialInfo: '物料信息',
      variantMap: '换料映射',
      variantMapSimple: '映射',
      sizeExplain: '规格说明',
      sizeTemplates: '版库',
      sizeTemplateInfo: '版库情况',
      supplierPrice: '供应商价格',
      supplierSizePrice: '供应商规格价',
      supplierProductNo: '供应商货号',
      defaultSupplier: '默认供应商',
      quotation: '报价',
      verifyInfo: '审核情况',
      verify: '审',
      ingredientInfo: '配料情况',
      matchPhaseInfo: '配工序情况',
      supplierInfo: '供应商情况',
      privatizeInfo: '转化情况',
      specJson: '自定义属性',
      attachment: '附件',
      attachmentExplain:
        '限制word、Excel、png/jpg/jpeg/gif、PDF、PLT、plt、zip、rar格式',
      productSizeTemplate: '文件',
      shopImages: '销售图片',
      productNoRepeat: '异常产品',
      isScore: '积分产品',
      score: '积分',
      showPrice: '展示价格',
      depositPrice: '预付款金额',
      lifeCycle: '生命周期',
      salesCurrency: '售价币种',
      mesCycle: '生产周期',
      remark: '产品备注',
      mainMaterial: '主料',
      productHsInfo: '海关属性',
    },
    sizeTemplateInfos: {
      yes: '有版库',
      no: '无版库',
    },
    privatizeInfos: {
      yes: '已转化',
      no: '未转化',
    },
    productMixStates: {
      mixing: '配料中',
      mixed: '已配料',
      unMix: '未配料',
      null: '未配料',
    },
    matchPhaseInfos: {
      no: '未配工序',
      yes: '已配工序',
    },

    inquiryTypes: {
      public: '公开询价',
      private: '私下询价',
    },
    quotation: {
      price: '报价',
      sizePrice: '规格报价',
      createAt: '报价日期',
      hasInv: '有库存',
      quantity: '已共享产品数量',
      discount: '折扣',
      original: '原价的',
      discountRate: '折扣率',
      unQuotation: '未报价',
      quotationInfo: '报价情况',
    },
    quotationInfos: {
      yes: '已报价',
      no: '未报价',
    },
    inquiry: {
      type: '询价方式',
      expirateAt: '截止日期',
      serialNo: '询价单号',
      inquiryAt: '询价日期',
      minPrice: '最低报价',
      lastPrice: '最后报价',
      quoteAt: '报价日期',
    },

    inquiryTypes: {
      public: '公开询价',
      private: '私下询价',
    },
    phase: {
      phaseHour: '工时(小时)',
      period: '制作周期(天)',
      inspect: '半检',
      price: '单价',
      subtotal: '小计',
      baseCost: '人工成本',
      asyncUnFinishWO: '同步到未完成工单',
    },
    material: {
      mainMaterial: '主料',
      serialNo: '料号',
      name: '品名',
      serialNoName: '料号 品名',
      color: '颜色',
      colorNo: '色号',
      quantity: '用量',
      price: '单价',
      inPrice: '进料单价',
      outPrice: '用料单价',
      subtotal: '小计',
      sizeQuantity: '规格用量',
      subject: '科目',
      baseQuantity: '用量',
      baseCost: '物料成本',
      unit: '单位',
      outUnit: '用料单位',
      inUnit: ' 进料单位',
      exchange: '换算比',
      //
      requireQty: '需求量',
      deficitQty: '盈/缺',
      deficitQty2: '缺',
      storeQuantity: '库存量',
      loadingQty: '在途量',
      unQualityQty: '待质检量',
      unStorageQty: '未确认入仓量',
      cashQuantity: '超发余量',
      giveCashQuantity: '余量扣减',
      invDiffQuantity: '库存扣减',
      serialNoRepeat: '异常物料',

      supplierSerialNo: '供应商料号',

      handCycle: '货期(天)',
      minHandCycle: '最小交货周期',
      maxHandCycle: '最大交货周期',
      minHandCycle2: '货期-最小(天)',
      maxHandCycle2: '货期-最大(天)',
      supplierMaterialNo: '供应商料号',
      // storageNo: '未确认入仓'
      // invInfo: '库存情况',
      // materialInfo: '物料信息'

      // sizesQuantityRate: '用量递增(%)'
    },
    inventory: {
      invCashQuantity: '库存量/超发余量',
      quantity: '库存数量',
      storeQuantity: '库存量',
      totalLock: '锁定数量',
      warnQuantity: '报警数量',
      alertQuantity: '报警量',
      invLockQty: '库存/锁定',
      lock: '锁定',
      remainQuantity: '剩余数量',
      totalQuantity: '总库存量',
      minQuantity: '数量-最小',
      maxQuantity: '数量-最大',
      manualLockQuantity: '锁定数量',
      manualLockQuantity2: '手动锁定量',
      pengingStockInQty: '待入库数量',
      onTheWayQty: '在途量',
      inventoryInfo: '库存情况',
      inventoryQty: '库存量',
      inventoryInfoNoExist: '库存不存在',
      lastCheckAt: '最后盘点日期',
      lastInAt: '最后入库日期',
      lastOutAt: '最后出库日期',
      unCheck: '未盘点',
      actualQuantity: '实际量',
      initAt: '第一次入库日期',
      stockAge: '库龄(天)',
      minStockAge: '库龄-最小',
      maxStockAge: '库龄-最大',
    },
    stock: {
      viewStockInOutDetail: '查看所有出入库明细',
      productNoQty: '货号数',
      productAmount: '产品总量',
      stockInType: '入库类型',
      stockOutType: '出库类型',
      type: '出入库类型',
      stockInQuantity: '入库数量',
      stockOutQuantity: '出库数量',
      totalQuantity: '总数量',
      associateSerialNo: '相关单号',
      ownerIn: '入库人',
      ownerOut: '出库人',
      serialNoIn: '入库单号',
      serialNoOut: '出库单号',
      createAtIn: '入库日期',
      createAtOut: '出库日期',
      andPick: '同时立即出库',
      shelf: '出库库位',
    },
    stockInType: {
      init: '初始化',
      check: '盘点',
      arrive: '到货',
      allocate: '调拨',
      rework: '返工入库',
      other: '其他',
      returnBack: '退货入库',
      prepared: '备货入库',
      processed: '生产入库',
      rent: '租赁入库',
    },
    stockOutType: {
      sales: '销售', // 2021-05-24 之前用这个后面详细销售类型就不用了
      check: '盘点',
      allocate: '调拨',
      damage: '报损',
      rework: '返工出库',
      other: '其他',
      returnBack: '退货出库',
      // prepared: '备货出库', // 2019年用这个类型，后面改为销售
      rent: '租赁出库',
      salesPrepared: '销售-现货',
      salesPurchase: '销售-外采',
      salesProcess: '销售-生产',
      prepared: '现货',
    },
    pickShelfTypes: {
      delivery: '发货',
      // damage: '报损',
      allocate: '调拨',
      // inventoryRework: '库存返工',
      purchaseRemake: '外采改制',
      manufactureRemake: '生产改制',
      Purchase: '采购退货出库',
      Order: '客户强制收货出库',
    },
    pushShelfType: {
      purchaseReceive: '外采',
      purchaseForceReceive: '外采',
      purchaseRework: '外采',
      purchaseChangeSpecsForceReceive: '外采',
      purchaseChangeSpecsReceive: '外采', // 采购改码收货
      manufactureReceive: '生产',
      manufactureForceReceive: '生产',
      manufactureRework: '生产',
      inventoryRework: '库存返工',
      returnBack: '退货',
      returnBackRework: '退货', //退货返工
      allocate: '调拨',
    },
    damage: {
      remark: '报损原因',
      voucher: '报损凭证',
      verifyInfo: '审核信息',
      rejectReason: '拒绝原因',
    },
    rework: {
      remark: '返工原因',
      voucher: '返工凭证',
      finishAt: '完成日期',
      ownerName: '发起人',
      finisherName: '完成人',
      reworkInfo: '返工情况',
      reworkSource: '返工来源',
      markFinishAt: '标记完成日期',
    },
    reworkInfos: {
      yes: '已完成',
      no: '未完成',
    },
    reworkSources: {
      my: '我的返工',
      customer: '客户返工',
    },

    workOrder: {
      serialNo: '工单号',
      processedAt: '生产完成日期',
      finishAt: '出货完成日期',
      qualityRecords: '质检记录',
      checkAt: '质检日期',
      checkerName: '质检人',
      reworkInfo: '返工情况',
      shipInfo: '出货情况',
      shipAt: '出货日期',
      shiperName: '出货人',
      recentPhase: '最近工序',
      printWorkOrder: '在产',
      unFinished: '未出货',
      phaseProcessingInfo: '工序完成情况',
      distributedQuantity: '已派发数量',
      distributQuantity: '派发数量',
      inProduction: '在产',
      deliveryQuantity: '发货数量',
      shipQuantity: '收货数量',
      ship: '收货',
      productionSituation: '生产情况',
      receiveRecords: '接收记录',
      qaRecords: '尾查记录',
      reworkRecords: '返工记录',
      shipSituation: '出货情况',
      receiveAt: '接收日期',
      receiverName: '接收人',
      checkAt: '尾查日期',
      checkerName: '尾查人',
      qaInfo: '尾查情况',
      receiveQuantity: '接收数量',
      qaQuantity: '尾查数量',
      shipForceQuantity: '强收',
      placeAt: '下单日期',
      scheduleAt: '开工日期',
    },
    manufacture: {
      productionInfo: '生产情况',
      needInspectInfo: '需半检',
      inspectInfo: '半检情况',
      salaryInfo: '结算情况',
      overdueInfo: '超期情况',
      startAt: '生产开始日期',
      endAt: '生产结束日期',
      total: '总工价',
    },
    overdueInfos: {
      yes: '超期',
      no: '未超期',
    },
    salaryInfos: {
      yes: '已结算',
      no: '未结算',
    },
    inspectInfos: {
      yes: '已半检',
      no: '未半检',
    },
    productionInfos: {
      yes: '已结束',
      no: '未结束',
    },
    phaseProcessingInfos: {
      undo: '未开始',
      doing: '生产中',
      done: '已完成',
    },
    qaInfos: {
      receivedPendingQa: '已接收未尾查',
      pendingQaYes: '待尾查',
      pendingQaNo: '已尾查',
    },

    allocate: {
      serialNo: '调拨单号',
      applyDepartInfo: '申请方信息',
      acceptDepartInfo: '受理方信息',
      applyRemark: '申请说明',
      acceptRemark: '受理备注',
      applyDepartName: '申请仓',
      acceptDepartName: '受理仓',
      inOperatorName: '入库信息',
      allocateType: '调拨类型',
      applyAt: '申请时间',
      applyDepart: '申请方',
      applyName: '申请人',
      acceptAt: '受理时间',
      acceptDepart: '受理方',
      acceptName: '受理人',
      allocateCountType: '操作',
      inOperatorName: '入库人',
      rejectReason: '拒绝原因',
    },
    countDay: {
      today: '今天',
      yesterday: '昨天',
      week: '本周',
      lastweek: '上周',
      month: '本月',
      lastmonth: '上月',
    },
    allocateTypes: {
      in: '申请调入',
      out: '申请调出',
    },
    allocateCountTypes: {
      pendingIn: '待入库',
      pendingOut: '待出库',
    },
    allocateWorkflowState: {
      applying: '新的',
      outed: '出库',
      rejected: '拒绝',
      ined: '入库',
      cancel: '取消',
      picking: '待出库',
      pushing: '待入库',
    },
    allocateWorkflowStateMms: {
      applying: '新的',
      outed: '出库',
      rejected: '拒绝',
      ined: '入库',
    },
    damageWorkflowStates: {
      newly: '待审核',
      agreed: '同意',
      rejected: '拒绝',
      outed: '出库',
    },
    pickListWorkflowStates: {
      newly: '新的',
      partially: '部分出库',
      finish: '完成',
    },
    snapshoot: {
      snapDate: '日期',
      productNoQty: '货号数',
      quantity: '产品量',
      materialQty: '料号数',
      quantityMms: '料号量',
    },
    customer: {
      serialNo: '客户编号',
      email: 'Email/QQ/微信',
      email2: 'Email',
      zipcode: '邮编',
      source: '来源',
      jyAccount: '有简赢账户',
      nojyAccount: '无简赢账户',
      settleType: '现结',
      balance: '账户余额',
      balance2: '余额',
      phoneSerialNo: '电话/编号',
      company: '公司名称',
      customerInfo: '客户信息',
      addressInfo: '地址信息',
      follow: '跟踪',
      rechargeAmount: '充值金额',
      isMember: '会员',
      customerProvinceCode: '省份代码',
    },
    customerTypes: {
      retail: '零售',
      wholesale: '批发',
    },
    supplier: {
      replaceDeliver: '代发货',
      url: '外采地址',
      price: '外采单价',
      showTerminalInfo: '可以显示终端客户名称、售价',
      namePhone: '名称 电话',
      handCycle: '交货周期',
      dailyCapacity: '日产能',
      hidden: '暂不合作',
      showSizeTemplate: '展示版库',
    },
    bargain: {
      serialNo: '订单号',
      currency: '收款币种',
      saleAmount: '销售额',
      amount: '成交额',
      payAmount: '收款额',
      customerType: '客户类型',
      productQty: '产品数',
      receive: '收',
      differ: '欠',
      ignore: '抹',
      settled: '已结清',
      leave: '余',
      salesSlip: '销售清单',
      receivePaymentInfo: '收款情况',
      ordersTotal: '总价',
      actualReceive: '实收',
      actualReceive2: '实收额',
      differReceive: '欠收',
      leavePayAmount: '结余',
      diffAmount: '差额',
      // currentMonthAmount: '当月成交额',
      // // palceCustomer: '下单客户'
      financeVerifyInfo: '财务审核情况',
      payInfoInfo: '结算情况',
      deliveryRemark: '发货备注',
      customerInfo: '客户信息',
      customerName: '客户姓名',
      customerPhone: '客户电话',
      customerAddress: '客户地址',
      customerZipcode: '客户邮编',
      orderAmount: '订单金额',
      settleType: '收款类型',
      payment: '订单收款',
      paymentInfo: '收款信息',
      remark: '订单备注',
      remarkExplain: '仅业务员能看到，不能传到后续流程，如外采、生产等',
      bargainInfo: '销售单信息',
      financeDelivery: '发货审核',
      deliveryInfo: '发货信息',
      getTrackingFail: '申请运单号异常',
      latestShipDate: '最晚发货',
      latestDeliveryDate: '最晚送达',
    },

    orderTypes: {
      custom: '定制', //定制
      bulk: '大货', // 大货
      wholesale: '批发',
    },
    dealOrderTypes: {
      custom: '定制',
      bulk: '大货',
      remake: '改制',
    },
    settleTypes: {
      later: '账单结算',
      now: '现结',
    },
    payInfoInfos: {
      yes: '已结清',
      no: '欠款',
    },
    order: {
      serialNo: '订单项号',
      hurry: '加急',
      hurrySimple: '急',
      innerSerialNo: '内部单号',
      salePrice: '销售单价',
      salePriceSimple: '售',
      price: '成交单价',
      subtotal: '小计',
      customerProductNo: '客户货号',
      settlement: '已结算?',
      handler: '经办人',
      handleDepart: '经办部门',
      confirmAt: '确认日期',
      extraCharge: '附加费',
      extraChargeSimple: '附',
      productPrice: '售价',
      productPriceSimple: '售',
      dealType: '处理方式',
      confirm: '确认',
      dealAt: '处理日期',
      cancel: '取消',
      sign: '标记',
      cancelAt: '取消日期',
      cancelReason: '取消原因',
      return: '退货',
      returnAt: '退货日期',
      returnReason: '退货原因',
      dealQuantity: '完成数量',
      dealRemark: '处理说明',
      printAt: '打印日期',
      orderDeliverInfo: '订单配货情况',
      complete: '完成',
      deliveredQuantity: '已发数量',
      unDeliveredQuantity: '未发数量',
      deliverQuantity: '发货数量',
      currentDeliverQuantity: '本次发货数量',
      receiveQuantity: '收货数量',
      replenish: '备货',
      giveAt: '下单日期',
      operatorName: '处理人',
      preparedDealAt: '备货完成日期',
      mesWorkOrderState: '工单状态',
      dispatchAt: '派单日期',
      planEndAt: '计划结束日期',
      productionInfo: '生产情况',
      dealtAt: '处理完成日期',
      receiveShopName: '收入',
      signReceiveShopName: '标记收入',
      discountRate: '折扣(%)',
      discountRate2: '折扣',
      orderResource: '订单来源',
      colorImage: '颜色图片',
      finishAt: '交货完成日期',
      delivered: '已发',
      customerReceiveAt: '客户收货完成日期',
      customerReceiveAt2: '收货完成日期',
      terminalCustomerName: '终端客户',
      dealSuggest: '处理参考',
      settlementRemark: '结算备注',
      // orderRemark: '订单项备注',
      orderRemark: '注记',
      remark: '订单项备注',
      nearRange: '近交期',
      passRange: '过交期',
      debt: '欠款',
      balance: '有结余',
      unComplated: '未完成',
      asyncPdm: '同步到产品中心',
      wmsInfo: '库存量/锁定量',
      replenishQuantity: '备货数量',
      warehouse: '备货仓',
      orderInfo: '订单项信息',
      productInfo: '产品信息',
      reworkInfo: '返工信息',
      dealInfo: '处理信息',
      isScore: '积分订单',
      type: '订单类型',
      rejectQty: '被供应商拒绝',
      placeCustomerName: '下单客户',
    },
    orderMes: {
      sizeTemplate: '有版',
      price: '生产单价',
      pauseAt: '暂停日期',
      planStartAt: '计划开始日期',
      planEndAt: '计划完成日期',
      dispatchType: '派单方式',
      dispatchNumber: '派单分包',
      handOverAtAdvanceDay: '交期提前',
      customerCancel: '客户取消',
      certainAt: '确认日期',
      mmsRemark: '物料备注',
    },
    replenish: {
      serialNo: '备货单号',
    },
    mesOrder: {
      price: '生产价',
    },
    dealInfos: {
      pause: '暂不处理',
      needDeal: '需要处理',
    },
    dealDeliveryInfos: {
      pause: '暂不发货',
      needDeal: '需要发货',
    },
    orderResources: {
      followYes: '自己录入',
      followNo: '客户下单',
    },
    balance: {
      content: '说明',
      fee: '金额',
      operator: '处理人',
      type: '类型',
      payMethod: '方式',
      conditions: '筛选条件',
      in: '充值',
      out: '消费',
    },
    verify: {
      dealType: '审核情况',
      commentAt: '审核日期',
      commentName: '审核人',
      comment: '审核备注',
      comment2: '拒绝原因',
    },
    verifyInfos: {
      agree: '审核通过',
      reject: '审核拒绝',
      no: '未审核',
      yes: '已审核',
    },
    verifyTypesSimple: {
      agree: '过',
      reject: '拒',
    },
    orderDealTypes: {
      available: '现货',
      manufacture: '生产',
      purchase: '外采',
      // pause: '暂不处理'
    },
    payment: {
      totalReceive: '收款金额',
      total: '金额',
      payMethodReceive: '收款方式',
      payMethod: '方式',
      paidAt: '日期',
      explain: '说明',
      explainReceive: '收款说明',
      voucher: '凭证',
      voucherReceive: '收款凭证',
      ownerName: '收款人',
      ignoreAmount: '抹零',
      receiveAt: '收款日期',
      type: '收款类型',
      shop: '收款店铺',
    },
    delivery: {
      uploadAt: '上传日期',
      serialNo: '发货单号',
      serialNoTracking: '发货单号 跟踪号',
      scanSerialNoTracking: '扫描发货单号或跟踪号',
      deliveryMethode: '发货方式',
      deliveryType: '发货方式',
      agent: '货代方式',
      express: '快递公司',
      channel: '渠道',
      tracking: '跟踪号',
      tracking2: '运单号',
      remark: '发货备注',
      sender: '送货人',
      deliverCost: '费用',
      toPay: '到付',
      weight: '重量',
      courierWeight: '快递重量kg',
      insured: '保价额',
      deliverInfo: '发货情况',
      settle: '标记结算',
      settled: '已标记结算',
      settleAt: '结算日期',
      mCourierCostItemVerifyAt: '对帐日期',
      batchSerialNo: '发货批次',
      batchSerialNoSimple: '批次',
      goodsName: '中文品名',
      goodsNameEn: '英文品名',
      hsCode: '海关编码',
      deliverBy: '发货人',
      deliverAt: '发货日期',
      deliveryInfo: '发货信息',
      //
      importTracking: '导入跟踪号',
      importTracking: '导入跟踪号',
      importWeight: '导入重量',
      importCost: '导入费用',
      deliveryWeight: '发货重量',
      deliveryCost: '发货费用',
      costExplain: '价格说明',
      importCostExplain: '导入价格说明',
      resultType: '导入结果',
      settlementId: '核对',
      shop: '发货仓',
      checked: '已校验',
      checkName: '校验人',
      checkAt: '校验日期',
      weighted: '已称重',
      weightName: '称重人',
      weightAt: '称重日期',
      changeTracking: '转单号',
      monthDeliverycount: '本月发货单数',
      todayDeliverycount: '今天发货单数',

      //
      tinNumber: '税务号',
      length: '长',
      width: '宽',
      height: '高',
      currency: '结算币种',
      customsValue: '商品总额',
      aliexpressShipAt: '发货通知日期',
      serviceName: '物流名称',
    },
    deliverTypes: {
      express: '快递',
      carry: '送货',
      take: '自提',
      agent: '货代',
      signDeliver: '标记发货',
      normal: ''
    },

    orderStates: {
      placed: '待接单',
      confirming: '新的',
      pending: '未处理',
      preparing: '备货中',
      prepared: '备货完毕',
      processing: '生产中',
      processed: '生产完成',
      purchasing: '外采中',
      purchased: '外采完成',
      forout: '待出库',
      partially: '部分交货',
      finished: '交货完成',
      shipped: '交运',
      returned: '客户退货',
      canceled: '客户取消',
      all: '全部完成',
      dealing: '处理中',
      dealed: '处理完成',
    },

    orderStatesNoPermit: {
      placed: '待接单',
      confirming: '新的',
      pending: '未处理',
      preparing: '处理中',
      prepared: '处理完成',
      processing: '处理中',
      processed: '处理完成',
      purchasing: '处理中',
      purchased: '处理完成',
      partially: '部分交货',
      finished: '交货完成',
      shipped: '交运',
      returned: '客户退货',
      canceled: '客户取消',
      forout: '待出库',
    },
    purchaseStates: {
      newly: '新的',
      gived: '下单',
      accepted: '已接单',
      holding: '受理中',
      holded: '受理完毕',
      partially: '部分收货',
      finished: '收货完成',
      untrod: '退货',
      canceled: '取消',
    },
    mesOrderStates: {
      newly: '新的',
      dispatched: '已派单',
      processing: '生产中',
      processed: '生产结束',
      finished: '出货结束',
      canceled: '取消',
    },
    workOrderStates: {
      newly: '新的',
      processing: '生产中',
      processed: '生产结束',
      checked: '尾查结束',
      finished: '出货结束',
      canceled: '取消',
    },

    purchase: {
      serialNo: '外采单号',
      workflowState: '外采单状态',
      receive: '已收',
      receiveNo: '未收',
      qualityQuantity: '入库',
      reworkQuantity: '返工',
      price: '外采价',
      giveAt: '下单日期',
      receiveAdress: '收货地址',
      receiveQuantity: '收货数量',
      dealtAt: '外采完成日期',

      finishAt: '收货完成日期',
      purchaseing: '外采中',
      settlement: '账单结算',
      settlement2: '账单',
      manualSettle: '标记结算',
      settleInfo: '结算情况',
      settleCheckInfo: '对帐情况',
      supplierDeliveryAt: '供应商发货完成日期',
      replaceDeliver: '代发货',
      changeSpecsQuantity: '改码数量',
      noChangeSpecsQuantity: '正常数量',
      untreadAt: '退货日期',
      untreadReason: '退货原因',
      purchaseInfo: '外采单信息',
      untrodInfo: '退货情况',
      presentReceiveQuantity: '本次收货数量',
      receiveHandDiffDay: '延期',
      orderCancelAt: '订单取消日期',
      orderCancel: '客户取消', //(销售订单)
      manualSettleAt: '标记结算',
      handOverAt: '供应商交期',
      purchaseRemark: '注记',
    },
    settleInfo: {
      yes: '已结算',
      no: '未结算',
    },
    signSettleInfos: {
      yes: '已标记',
      no: '未标记',
    },
    settleCheckInfo: {
      yes: '已对帐',
      no: '未对帐',
    },
    returnBack: {
      haveGood: '货退回',
      remark: '退货原因',
      total: '退款金额',
      payMethod: '退款方式',
      returnBackInfo: '退货情况',
      receiverName: '收货人',
      receiveAt: '收货日期',
      deliverySerialNo: '原发货单号',
      deliceryTracking: '原跟踪号',
      returnTracking: '退货跟踪号',
    },
    remake: {
      price: '改制价',
      disableStockOut: '不出库',
    },
    pickShelf: {
      pickedQuantity: '已出库数量',
      pickedQty: '已拣',
      pickQuantity: '出库数量',
      picker: '出库人',
      pickAt: '出库日期',
      finishAt: '出库完成日期',
      pickShelfInfo: '拣货情况',
      pickListInfo: '出库清单情况',
      shelfPathSet: '推荐路径',
      orderDetail: '相关订单',
      dealName: '处理人',
      dealInfo: '处理情况',
    },
    dealInfo: {
      yes: '已处理',
      no: '未处理',
    },
    pickShelfInfo: {
      yes: '已出库',
      no: '未出库',
    },
    pickListInfos: {
      yes: '已生成',
      no: '未生成',
    },
    pushShelf: {
      pusher: '入库人',
      pushAt: '入库日期',
      finishAt: '入库完成日期',
      pushedQuantity: '已入库数量',
      pushQty: '已入库',
      pushQuantity: '入库数量',
      pushShelfInfo: '入库情况',
    },
    pushShelfInfos: {
      yes: '已入库',
      no: '未入库',
    },

    schedule: {
      title: '标题',
      type: '类型',
      planAt: '时间',
      content: '内容',
      state: '状态',
      dutyPerson: '值班人员',
      scheduleInfo: '日程信息',
    },

    scheduleStates: {
      undo: '未做',
      done: '已完成', // “转化”   //做了买了
      // doing: '正在做',
      canceled: '取消',
      giveUp: '放弃', // 做了没买
    },

    rent: {
      serialNo: '租赁单号',
      rentAt: '使用日期',
      rentsSlip: '租赁清单',
    },
    clean: {
      serialNo: '清洗单号',
      rentAt: '清洗日期',
      cleansSlip: '清洗清单',
    },
    cleanItem: {
      serialNo: '清洗项单号',
    },
    rentItem: {
      serialNo: '租赁单项号',
      price: '租赁单价',
      outName: '出库人',
      finishName: '完成人',
    },
    rentStates: {
      newly: '新的',
      outed: '出库',
      finished: '完成',
    },
    salesTarget: {
      month: '月份',
      target: '目标销售额',
      complete: '完成销售额',
      completeRate: '完成比例',
      detailInfo: '详细信息',
      userName: '人员',
    },
    deliveryRequisition: {
      serialNo: '申请单号',
      applyName: '申请人',
      quantity: '申请数量',
      commentName: '发货人',
      handOverAt: '申请发货日期',
    },
    deliveryRequisitionDealTypes: {
      agree: '发货',
      no: '未发货',
    },
    deliveryBeforehand: {
      quantity: '预发货数量',
    },
    verifyTypes: {
      agree: '通过',
      reject: '拒绝',
    },
    verifyTypesSimple: {
      agree: '过',
      reject: '拒',
    },
    settlement: {
      title: '标题',
      orderQuantity: '订单数',
      purchaseQuantity: '外采单数',
      productQuantity: '产品数',
      amount: '总金额',
      giveAmountReceiveAmount: '收款额/确认额',
      giveAmountPayAmount: '付款额/确认额',
      receiveAmount: '收款额',
      payAmount: '付款额',
      giveAmount: '付款额',
      payAmountConfirm: '确认额',
      receiveInfo: '收款信息',
      paymentInfo: '付款信息',
      diffAmount: '欠款额',
      receiveoffAt: '收款完成日期',
      payoffAt: '付款完成日期',
      direction: '结算方向',
      directionsCustomer: {
        Order: '我给客户',
        Purchase: '客户给我的',
      },
      directionsSupplier: {
        Order: '供应商给我的',
        Purchase: '我给供应商的',
      },
      verifyAt: '对账日期',
      verifyExplain: '对账说明',
      selfVerifyAt: '核对日期',
      selfVerifyExplain: '核对说明',

      // paymentReceiveInfo: '收款情况',
      // paymentReceiveInfoS: '付款情况',
      // detail: '明细',
      settleTotal: '结算金额',
      explain: '结算说明',
      dateType: '日期类型',
      dateRange: '日期范围',
      totalQuantity: '总单数',
      settlerNameDelivery: '对账人',
      settleAtDelivery: '对账时间',
      payoffAtDelivery: '付款日期',
      settlerName: '结算人',
      settle: '结算',
      searchCondition: '查询条件',
      salaryAmount: '应发额',
      quantity: '生产数量和',

      errorExplain: '问题说明',
    },
    monthSettlement: {
      productCost: '产品成本',
      deliverCost: '发货成本',
      payAmount: '当期收款额',
      returnAmount: '退货成交额',
      returnProductCost: '退货产品成本',
    },
    deliverCheck: {
      quantity: '总数量',
      successQuantity: '成功',
      warnQuantity: '警告',
      failQuantity: '失败',
    },
    resultTypes: {
      fail: '失败',
      warning: '警告',
      success: '成功',
    },
    dateTypes: {
      finishAt: '交货完成日期',
      finishAtMms: '完成日期',
      customerReceiveAt: '客户收货日期',

      createAt: '创建日期',
      placeAt: '下单日期',
      receiveAt: '收货完成日期', //finishAt
      supplierDeliveryAt: '供应商发货日期',
    },
    dateTypesMms: {
      createAt: '创建日期',
      placeAt: '下单日期',
      finishAt: '完成日期',
    },
    dateTypesMes: {
      createAt: '创建日期',
      finishedAt: '收货日期',
    },
    synchronizeEdition: {
      synchronizeInfo: '同步情况',
      synchronizeName: '同步操作人',
      synchronizeAt: '同步日期',
      property: '更新字段',
      old: '订单原值',
      newly: '订单更新值',
      purchasePropValue: '外采单对应值',
      purchaseEdition: '外采单对应更新后的值',
    },
    synchronizeInfos: {
      yes: '已同步',
      no: '未同步',
    },
    synchronizeEditionPropertys: {
      hurry: '加急',
      serialNo: '订单项号',
      quantity: '数量',
      price: '价格',
      specJson: '自定义属性',
      attachment: '附件',
      colorImage: '颜色图片',
      dealRemark: '处理说明',
      workOrderState: '状态',
      handOverAt: '交货日期',
      productNo: '货号',
      color: '颜色',
      size: '规格',
      images: '图片',
      categoryName: '分类',
      unit: '单位',
      remark: '备注',
      craftwork: '制作工艺',
      customerProvince: '省份',
      customerCity: '城市',
      customerAddress: '地址',
      customerZipcode: '邮编',
      customerName: '客户姓名',
      customerCountry: '国家',
    },
    hang: {
      serialNo: '订单号',
      hangSerialNo: '被挂(生产)订单号',
      finishAt: '结束日期',
      hangInfo: '挂单情况',
    },
    hangInfos: {
      yes: '已完成',
      no: '未完成',
    },
    procure: {
      serialNo: '采购单号',
      buyerName: '下单人',
      placeAt: '下单日期',
      finishAt: '完成日期',
      procureItem: '采购单项',
      verifyAt: '审核日期',
      verifyName: '审核人',
      procureInfo: '采购单信息',
      receiveQuantity: '实收数量',
      qualifiedQuantity: '可用数量',
      receiverInfo: '收料情况',
    },
    procureTypes: {
      newly: '新的',
      placed: '下单',
      partially: '部分收料',
      finish: '收料',
    },
    stockInTypesMms: {
      arrive: '采购收料入库',
      returnBack: '退料收料入库',
      check: '盘点入库',
      allocate: '调拨入库',
      other: '其他',
      cash: '超发余量',
      restore: '退仓',
    },
    stockOutTypesMms: {
      give: '发料出库',
      check: '盘点出库',
      allocate: '调拨出库',
      returnedMaterial: '退料出库',
      other: '其他',
      cash: '超发余量',
    },
    pendingRequisition: {
      calcMaterialAt: '是否配料',
      takeMaterialAt: '发料日期',
      subjectsJson: '已发科目',
      createProcureAt: '生成采购单日期',
      giveInfo: '发料情况',
      createProcureInfo: '采购单生成情况',
    },
    createProcureInfos: {
      yes: '已生成',
      no: '未生成',
    },
    giveInfos: {
      yes: '已发料',
      no: '未发料',
      part: '部分发料',
    },
    requisition: {
      serialNo: '发料单号',
      finishAt: '完成日期',
      orderDetail: '相关订单',
      purchaseDetail: '相关采购单',
      // dept: '领料单位',
      dept: '领料部门',
      manageSubjects: '管理科目',
      //
      givedQuantity: '已发数量',
      giveQuantity: '发料数量',
      giveWarehouseName: '发料仓',
      ownerName: '发料人',
      createAt: '发料时间',
      isLink: '存在未配料的，是否发料',
      changeMaterial: '替换物料',
    },
    requisitionTypes: {
      newly: '新的',
      partially: '部分发料',
      finish: '完成',
    },
    returnedMaterial: {
      serialNo: '退料单号',
      returnedMaterialItem: '退料单项',
      finishAt: '出库日期',
      finishName: '出库人',
    },
    mesOrderTypes: {
      custom: '销售定制单',
      remake: '销售改制单',
      // bulk: '备货单',
      bulk: '大货单',
    },
    flags: {
      red: '红旗',
      orange: '橙旗',
      yellow: '黄旗',
      green: '绿旗',
      cyan: '青旗',
      blue: '蓝旗',
      purple: '紫旗',
      clear: '清除旗帜',
    },
    weeks: {
      Monday: '周一',
      Tuesday: '周二',
      Wednesday: '周三',
      Thursday: '周四',
      Friday: '周五',
      Saturday: '周六',
      Sunday: '周日',
    },
    adapters: {
      taobao: '淘宝',
      aliexpress: '速卖通',
      ebay: 'Ebay',
      amazon: '亚马逊',
      shopify: 'Shopify',
    },
    requestResponse: {
      request: '请求',
      response: '响应',
      requestAt: '请求日期',
      plateform: '平台',
    },
    rrAdapterTypes: {
      NOTIFY: '消息',
      ASYNC_TRACKING: '上传跟踪号',
      E_ORDER: '电子面单',
      ACK_ORDER: '拉单',
    },
    rrAdapterPlateforms: {
      TAOBAO: '淘宝',
      EBAY: 'eBay',
      AMAZON: '亚马逊',
      SHOPIFY: 'shopify',
      ALIEXPRESS: '速卖通',
    },
    reports: {
      costProfit: '成本利润报表',
      returnDetail: '退货明细',
      paymentDetail: '收款额明细',
      synthesizeCostProfit: '毛利估算报表',
      omsPaymentDetail: '收款明细报表',
      omsWholesaleCustomerRanking: '大客户排名报表',
      omsProductSaleRanking: '产品销售排名报表',
      omsSalePerformance: '销售业绩报表',
      omsSaleLineChart: '日报月报年报',
      omsDiffDetail: '欠款明细报表',
      pmsPurchaseDetail: '外采明细报表',
      wmsInventoryCount: '库存统计报表',
      wmsMovingPinRate: '大货库存动销率报表',
      mesQa: '尾查报表',
      supplierOver: '供应商过交期报表',
    },
    report: {
      orderQty: '订单量',
      productQty: '货号数',
      qty: '件数',
      returnQty: '退款量',
      returnAmount: '退款金额',
      inQuantity: '入库数量',
      saleQuantity: '销售数量',
      remainQuantity: '库存数量',
      shelfSalesRatio: '动销率(%)',
      shopName: '所在店铺',
    },
    reportQa: {
      endAt: '尾查结束日期',
      startAt: '尾查开始日期',
      endAt: '尾查结束日期',
    },
    lianbang: {
      accountNum: '联邦快递账号',
      shippingAddress: '发货地址',
      shippingAddress_countryCode: '国家/地区',
      shippingAddress_stateOrProvinceCode: '地区编码',
      shippingAddress_city: '城市',
      shippingAddress_streetLines: '详细地址',
      shippingAddress_postalCode: '邮编',
      contactAndAddress: '联系人地址',
      contactAndAddress_personName: '联系人',
      contactAndAddress_firstName: '姓',
      contactAndAddress_lastName: '名',
      contactAndAddress_companyName: '公司名称',
      contactAndAddress_phoneNumber: '电话',
      contactAndAddress_emailAddress: 'Email',
      contactAndAddress_countryCode: '国家/地区',
      contactAndAddress_stateOrProvinceCode: '地区编码',
      contactAndAddress_city: '城市',
      contactAndAddress_streetLines: '详细地址',
      contactAndAddress_postalCode: '邮编',
    },
    newImport: {
      excelTemplate: 'Excel导入模板',
      beCareful: '注意',
      beCarefulMustFill: '必填项不填写，则忽略这条数据',
      results: '导入结果',
      clickDownload: '点击下载',
    },
    newImportVariantMap: {
      excelTitle: 'Excel文件列头：颜色(必填项)、替换料号、原配料料号(必填项)',
      beCarefulColor: '颜色必须是该产品下的颜色，否则忽略这条数据',
      beCarefulMaterial: '原配料料号必须是该产品下配料表的料号',
    },
    newImportProduct: {
      excelTitle:
        'Excel文件列头：货号(必填)，分类，单位(必填)，售价(必填)，成本价(必填)，批发价，颜色，规格，自定义属性，图片，描述，制作工艺，标签、品牌、销售规格价、成本规格价、售价币种、供应商',

      beCarefulCategory: '分类是设置中产品分类名称',
      beCarefulLabel: '标签列填写的是该产品所有标签，每个之间用英文分号(;)分割',
      beCarefulColor: '颜色列填写的是该产品所有颜色，每个之间用英文分号(;)分割',
      beCarefulSize: '规格列填写的是该产品所有规格，每个之间用英文分号(;)分割',
      beCarefulAttribute:
        '自定义属性列填写的是该产品所有自定义属性，每个之间用英文分号(;)分割',
      beCarefulImages: '图片列放的是图片链接，多个链接用英文分号(;)分割',
      beCarefulSalesPriceSizes:
        '销售规格价列填写的是该产品所有销售规格价，每个之间用英文分号(;)分割，例如：S:12;M:13;(不在规格列中的规格价将被忽略)',
      beCarefulCostPriceSizes:
        '成本规格价列填写的是该产品所有成本规格价，每个之间用英文分号(;)分割，例如：S:12;M:13;(不在规格列中的规格价将被忽略)',
      beCarefulSalesCurrency:
        '售价币种填写在设置里面设置过的国际标准码，不填写默认CNY(¥)',
      beCarefulSupplier:
        '供应商列填写的是 供应商名字:价格；每个供应商之间英文分号(;)分割，例如：一号供应商:100;二号供应商2:100(不在系统设置里面供应商的供应商将被忽略)',
    },
    newImportIngredient: {
      excelTitle:
        'Excel文件列头：货号(必填项)、料号(必填项)、基础用量(必填项)、备注',
      beCarefulMustFill: '货号、料号、基础用量必填，不填写,则忽略这条数据',
      beCarefulProductNo: '货号是产品中的货号，匹配不到则忽略这条数据',
      beCarefulMaterialSerialNo: '料号是物料中的料号，匹配不到则忽略这条数据',
    },
    newImportPhases: {
      excelTitle:
        'Excel文件列头：货号(必填项)、工序(必填项)、次序(必填项)、工时(必填项)、制作周期(必填项)、半检',
      beCarefulMustFill:
        '货号、工序、次序、工时、制作周期必填，不填写,则忽略这条数据',
      beCarefulPhases: '工序是设置中的工序，匹配不到则忽略这条数据',
      beCarefulInspect: '半检则填true,否则不填写',
    },
    newImportInventory: {
      excelTitle:
        'Excel文件列头：货号(必填)，颜色，规格，库位(必填)，数量(必填)、备注',
    },
    newImportCustomer: {
      excelTitle:
        'Excel文件列头：账户/电话(必填)，客户编号(必填)，姓名(必填)，公司名称，Email，类型(wholesale/retail)，来源，国家，省份，城市，地址，邮编，备注',
      beCarefulType: '类型分为批发和零售，批发填写wholesale，零售填写retail',
    },
    newImportBulk: {
      excelTitle:
        'Excel文件列头：订单项编号(必填)、货号(必填)、颜色、规格、数量(必填)、单位、价格(必填)、图片、备注、交货日期、内部单号、客户款号、若干自定义属性列(如：胸围、腰围...)',
    },
    newImportBargain: {
      excelTitle:
        'Excel文件列头：订单编号(必填)，交货日期，所属店铺(必填)，货号(必填)，颜色，规格，数量(必填)，单位，价格(必填)，分类(必填)，图片，产品备注，客户姓名(必填)，客户电话(必填)，客户来源，国家，省份，城市，邮编，地址，发货备注，收款类型(必填)，收款额，收款方式，收款说明，币种(必填)，分组，内部单号、客户货号、附加费、加急、若干自定义属性列(如：胸围、腰围...)',
      beCarefulShop: '店铺是设置中店铺名称，匹配不到则忽略这条数据',
      beCarefulCountry:
        '国家是二字码，如中国为CN，美国为US，导入模板的第二个Sheet2中给出对照表',
      beCarefulSettleType: '收款类型只有两种：现结填写now，账单结算填写later',
      beCarefulPaymentMethode:
        '收款方式是设置中收款方式名称，匹配不到则默认第一个',
      beCarefulCurrency:
        '币种填写国际标准码，如人民币是CNY，美元是USD，不填默认价格币种是人民币',
      beCarefulGroup: '分组列填写分组名，每个之间用英文分号(;)分割',
      // beCarefulDate: '时间格式例如：2019-01-01',
      beCarefulHurry: '加急则填写 true, 否则不填写',
      beCarefulSpecJson:
        '自定义属性列的格式为：名称:值。例如：胸围:100CM;腰围:40CM',
    },
    newImportReplenish: {
      excelTitle:
        'Excel文件列头：补货单号(必填)，货号(必填)、颜色、规格、数量(必填)、交期、加急、备注',
    },
    importPayment: {
      excelTitle:
        'Excel文件列头：订单编号(必填)，收款日期(必填)，收款金额(必填)，收款方式(必填)，说明',
    },
    importAmazon: {
      excelTitle: 'Excel文件列头：必须是亚马逊平台导出的Excel格式',
      beCarefulMustFill:
        '文件格式必须是亚马逊平台导出的Excel格式，若Excel中存在该订单号，则同步客户地址信息',
    },
    newImportMaterial: {
      excelTitle:
        'Excel文件列头：料号(必填项)、品名(必填项)、科目(必填项)、进料单位(必填项)、用料单位(必填项)、换算比(必填项)、颜色(必填项)、色号(必填项)、供应商、采购价、说明、图片',
      beCarefulImage: '图片一列放图片链接',
    },
    newImportSuppliersMms: {
      excelTitle:
        'Excel文件列头：名称(必填项)、联系人(必填项)、电话(必填项)、地址、备注',
    },
    newImportMaterialInventory: {
      excelTitle:
        'Excel文件列头：料号(必填项)、实际量(必填项)、报警量(必填项)、库位(必填项)',
    },
    newImportProcure: {
      excelTitle:
        'Excel文件列头：采购单号(必填项)、交货日期(必填项)、料号(必填项)、品名、数量(必填项)、单位(必填项)、进料单价(必填项)、供应商(必填项)、备注',
      beCarefulSerialNo: '采购单号一致则合并采购单',
    },

    newImportExpressSettlement: {
      excelTitle: 'Excel文件列头：跟踪号(必填)，重量，价格(必填)，价格说明',
      resultExplain: '显示红色，表明 导入数据 和 原本数据 不一致',
    },
    importDeliveryCheckAgent: {
      excelTitle: 'Excel文件列头：跟踪号/发货单号(必填)，价格(必填)，重量',
    },
    newImportShelf: {
      excelTitle: 'Excel文件列头：库位名称(必填)',
    },
    newImportWorker: {
      excelTitle: 'Excel文件列头：姓名(必填)，工号(必填)，管理工序',
      beCarefulPhases: '多个管理工序用,分割',
    },
    importCourierCost: {
      excelTitle: 'Excel文件列头：跟踪号/发货单号(必填)，费用',
      beCarefulFirst: '第一列是跟踪号或者发货单号取其中一个即可',
    },
    importTracking: {
      excelTitle: 'Excel文件列头：发货单号(必填)，跟踪号(必填)，价格',
    },
    newImportColor: {
      excelTitle: 'Excel文件列头：名称(必填)',
    },
    prompt: {
      atLeastOneDataCanOnlineDeclaration: '至少选择一条DHL发货的未申报过的发货单',
      registerSuccess: '注册成功',
      perfectInformationSuccess: '完善成功',
      addMorePrompt: '单次提交不能超过10条记录',
      addMorePrompt50: '单次提交不能超过50条记录',
      //
      addSuccess: '新增成功',
      delSuccess: '删除成功',
      editSuccess: '编辑成功',
      updateSuccess: '更新成功',
      editConfirmSuccess: '编辑确认成功',

      saveSuccess: '保存成功',
      confirmDelete: '确认删除？',
      confirmRemove: '确认移除？',
      confirmPause: '确认暂停生产？',
      confirmReManufacture: '确认恢复生产？',
      confirmPayOff: '确认收款完毕？',
      downloadPrompt: '请稍后到 下载文件 中下载',
      downloadErr: '下载失败',
      printErr: '打印失败',
      actionSuccess: '操作成功',
      //
      accountNotExist: '账户不存在',
      sendVerificationCode: '发送验证码',
      phoneRegistered: '该手机号已注册',
      //
      passwordAgain: '请再次输入密码',
      passwordDiffer: '两次输入密码不一致',
      logoExplain: 'LOGO建议尺寸64px*64px，小于500K，格式jpg、png',
      //
      authInfo: '授权信息',
      dataAuth: '数据授权',
      dataUserAuth: '用户',
      dataUserAuthExplain: '该账号可以看以下人员的相关数据',
      dataMmsSubjectAuthExplain: '该账号可以管理的科目',
      dataMesPhaseAuthExplain: '该账号可以管理的工序',
      dataWmsView: '库存查看',
      dataWmsViewExplain: '该账号可以查看的库存仓',
      dataWmsManage: '库存管理',
      dataWmsManageExplain: '该账号可以管理操作的库存仓',
      authSuccess: '授权成功',
      //
      alphabetNumber: '数字、字母',
      atLastOneAlphabet: '至少一个字母',
      // setInvalid: '此操作不可逆，确认设置失效?',
      setInvalid: '确认设置失效?',
      setSuccess: '设置成功',
      cancelSetSuccess: '取消设置成功',
      authQtyBeyond: '权限人员已达上限，请联系客服购买',
      errorMessage: '存在错误提示',
      atLeastOneValidDataFillIn: '至少填写一条有效数据',
      atLeastOneValidDataImport: '至少导入一条有效数据',
      atLeastOneValidData: '至少选择一条有效数据',

      shopNotDeleteExplain: '存在子账户属于该店铺下，不能删除',
      asyncInvExplain:
        '同步库存后，可能会导致业务数据统计不正确，谨慎操作同步库存！！！',
      //
      orderConfirmPromptProductNoIsNull: '选择的货号是空的订单',
      orderConfirmPromptIsConfirmed: '选择的都是已确认的订单',
      workerQtyBeyond: '工人数量已达上限',
      atLeastSelectOnePhase: '至少选择一个工序',
      atLeastOneDataNoTracking: '至少选择一条没有跟踪号的',
      atLeastTwoData: '至少选择两条数据',
      atLeastOneData: '至少选择一条数据',
      atLeastOneData2: '至少有一条数据',
      atLeastOneDataCanMaterialMapRecords: '至少选择一条未被映射的数据',
      atLeastOneDataUnProcessfinish: '至少选择一条未生产完成的数据',
      serialNoProcessfinish: '该单号已经生产完成',
      asyncPhasePlan: '更新工厂工单未开始的工序计划',
      asyncManufacture: '更新未结算的生产记录',
      hasBeenDockedPleaseAdd: '该块递已对接，请进行新增操作',
      undocked: '该货代公司不存在，请联系简赢公司处理',
      noDeliverMethod: '暂无发货方式',
      atLeastOneDealType: '至少选择一种处理方式',
      downloadSuccess: '下载成功',
      readSuccess: '阅读成功',
      refreshSuccess: '刷新成功',
      atLeastOneSupplier: '至少选择一个供应商',
      notExistCanInqueryProduct: '不存在可询价的产品(审核后的产品才可询价)',
      inquirySuccess: '询价成功',
      quotationExplainCustomer: '说明：只给客户类型是 “批发” 的客户报价',
      verifySuccess: '审核成功',
      selfVerifySuccess: '核对成功',
      selfMarkErrorSuccess: '问题标记成功',
      financeVerifyCancelSuccess: '反审核成功',
      asyncSuccess: '同步成功',
      noProductSize: '该产品没有规格',
      quotationSuccess: '报价成功',
      distributeCustomerSuccess: '分配成功',
      productNoNoPhaseInfo: '该货号下没有工序信息',
      productNoNoPhaseHasExist: '该货号下工序已存在',
      productNoNoBomInfo: '该货号下没有配料信息',
      productNoNoBomHasExist: '该货号下配料已存在',
      searchProductNoToAddPhases: '输入货号 加载货号下工序新增到该产品下',
      searchProductNoToAddMaterials: '输入货号 加载货号下物料新增到该产品下',
      noVariantMapColors: '该产品已没有未被映射过的颜色',
      needMapMaterial: '需要替换的物料',
      replace: '替换为',
      colorHasMaped: '该颜色下已有该替换物料',
      noSelectMapColors: '没有选择映射的颜色',
      noSelectMapBoms: '没有选择映射的物料',
      ingredientFinishSucess: '配料完成',
      productNoAliasExplain: '多个别名用“|”隔开',
      linkImageExplain: '每行一个图片链接，用回车键换行',
      noSelectSize: '未选择规格',
      atLeastOneUnVerifyData: '至少选择一条未审核的产品',
      atLeastMustFillProductsData: '至少选择一条有售价和成本价的产品',
      verifySuccess: '审核成功',
      downloadNoSearchCondition: '请选择筛选条件',

      noColorSizeIntersection: '选择产品没有共同的颜色规格',
      noColorSize: '选择产品没有颜色规格',
      productNoAsyncInvExplain:
        '同步库存后，可能会导致已存在货号的订单不能发货出库，请谨慎操作！！！',
      plaseConfirmAsyncInv: '请确认同步库存',
      confirmPrivatize: '该货号已转化过，确定再次转化',
      privatizeSuccess: '转化成功',
      quotationAddExplain: '说明：输入匹配，仅匹配 "批发" 客户',
      loadingComplete: '加载完毕',
      loading500: '已加载500条',
      loadingMore: '加载更多',
      quotationExplain:
        '注意：一次加载数量最大500条，如果多于500个产品，请分多次报价',
      exitQuotationNotEdit: '已有供应商报价，不能编辑',
      stockOutSuccess: '出库成功',
      stockInSuccess: '入库成功',
      damageSuccess: '报损成功',
      reworkSuccess: '返工成功',
      beyondMaxStockOutQty: '出库数量大于最大可出库数量',
      mesNoExistWorkerOrderSerialNo: '工厂不存在该工单',
      applySuccess: '申请成功',
      updateManualLockQtySuccess: '修改锁定量成功',
      placeSelectProductNo: '请先选货号',
      productNoColor: '此货号下没颜色',
      productNoSize: '此货号下没规格',
      hasBeenSelectProduct: '已选择过该产品',
      atLeastOneDataFill: '至少填写一条数据',
      checkSuccess: '盘点成功',
      rejectSuccess: '拒绝成功',
      confirmStockIn: '确认入库?',
      qtyBeyondMaxQty: '数量大于最大可申请数量',
      alphabetNumberLine: '字母、数字、-',
      regexAlphabetNumberLine: '编号只能是字母、数字、-',
      regexPassword: '密码需要至少8位，大写小写数字特殊字符混合',
      passwordPrompt: '密码需要至少8位，大写小写数字特殊字符混合',
      serialNoNamePhone: '编号、名称、电话',
      hasBeenAdded: '已添加过该账号',
      notAddOneself: '不能添加自己或子账户',
      notAddSubaccounts: '不能添加子账户',
      noAccount: '没有简赢账号',
      hasAccount: '有简赢账户,请去有简赢账户新增',
      createCustomerInput: '输入简赢账号，客户的手机号码',
      createSupplierInput: '输入简赢账号，供应商的手机号码',

      distributiveSuccess: '分配成功',
      rechargeSuccess: '充值成功',
      rechargeScoreSuccess: '积分操作成功',
      signSuccess: '标记成功',
      atLeastOneDataNoConfirm: '至少选择一条 待确认 且 有货号 的订单',
      confirmSuccess: '确认成功',
      cancelConfirmSuccess: '取消确认成功',
      atLeastOneDataExistDifferAmount: '至少选择一条 现结且有欠款 的订单',
      confirmBatchPaymentCompleted: '确认抹零',
      addGroupSuccess: '加入分组成功',
      delGroupSuccess: '取消分组成功',
      atLeastTwoBargain: '至少有两条订单',
      hasFinishedOrder:
        '不能合并交货完成、交运中、部分交货、取消、退货的订单项',
      noPlateformBargain: '存在不同平台导入的订单',
      noCurrencyBargain: '存在不同货币的订单',
      noAddressSelect: '请选择需要保留的地址信息',
      notFillSelfTenantPhone: '不能填写自己公司联系人的电话',
      existSameOrderSerialNoLocal: '存在存在相同的订单项编号',
      existSamePurchaseSerialNoLocal: '存在存在相同的采购单编号',
      existSameOrderSerialNoInv: '导入中存在与数据库中相同的订单项编号',
      customerBalanceNotEnougth: '账户余额不足',
      submitComfirmSuccess: '提交确认成功',
      submitSuccess: '提交成功',
      hurrySuccess: '加急成功',
      existFinishedOrderNotUpdate: '存在已完成的订单项不能批量修改',
      editHandOverAtSuccess: '更新交货日期成功',
      dealSuccess: '处理成功',
      dealError: '处理失败',
      returnSuccess: '退货成功',
      cancelSuccess: '取消成功',
      replenishmentNotAvailableDeal: "库存补货的不能进行'现货'操作",
      replenishmentNotKnockInvDeal: "库存补货的不能进行'别名撞库'操作",

      selectPrepareWarehouse: '请选择备货仓',
      preparedError: '备货完毕失败',
      purchaseMustFillSupplierHandOverAt:
        '存在没有选择 供应商 或者 交货日期 的数据',
      atLeastOneDataNoPause: '至少选择一条未暂不处理的订单',
      atLeastOneDataPause: '至少选择一条暂不处理的订单',

      confirmRetriveToPenging: '确认撤回待处理？',
      notExistDiffSpecPoduct: '库存中不存在不同码号的产品',
      changeSpecSuccess: '改码出库成功',
      printSuccess: '打印成功',
      placeExplain: '至少选择一条状态是新的采购单',
      atLastOneNewLyWorkOrder: '至少选择一条状态是新的工单',
      atLeastOneMaterialData: '至少有一条物料信息',
      batchEditPriceExplain: '至少选择一条状态不是取消退货的且未结算过的采购单',
      reminderExplain:
        '有简赢账户的且外采单状态是受理中、受理完毕、部分收货的，才可以进行催单',
      reminderSuccess: '催单成功',
      placeSuccess: '下单成功',
      signSettleSucces: '标记结算成功',
      rejectSuccess: '拒绝成功',
      invQtyNotEnough: '库存数量不足',
      noHangReplenish: '没有可挂的补货单',
      hangSuccess: '挂单成功',
      scanSerialNo: '扫描单号',
      notExixtSerialNo: '不存在该单号',
      exixtSerialNo: '存在该单号',
      workOrderProcessReceiveWorkflowStateExplain:
        '该单号已经生产完成或者已经取消',
      purchaseCanForceReceiveExplain: '该单号不存在可强制收货的数量',
      hasBeenScanSerialNo: '已扫描过该单号',
      receiveSuccess: '收货成功',
      receiveAndQualitySuccess: '收货质检成功',
      receiveAndQualityAndPushSuccess: '收货入库成功',
      receiveAndQualityAndDeliverySuccess: '收货发货成功',

      receiveMesSuccess: '接收成功',
      orderProcessReceiveWorkflowStateExplain:
        '该单号没有开始生产或者已经生产完成',
      serialNoHasQuality: '该单号已质检',
      selectDifferWarehouseData: '选择了不同仓的数据',
      replenishSuccess: '补货成功',
      deliveredQuantityBeyond: '存在发货数量大于最大发货数量或者等于0的订单',
      deliveredBeyondQuantity: '存在发货数量大于数量订单',
      theSameShippingNumber: '存在相同的发货编号！',
      deliverSuccess: '发货成功',
      deliverError: '发货失败',
      qualitySuccess: '质检成功',
      qualityDeliverySuccess: '质检发货成功',
      differExpress: '请勾选同一家国内快递公司进行打印面单',
      differAgent: '请勾选同一家货代方式进行打印面单',
      differBargainOrders: '请勾选在订单管理里面同一个订单下的订单',
      atLeastOneDataExpress: '至少选择一条国内快递的数据',
      atLeastOneDataAgent: '至少选择一条货代的数据',

      atLeastOneNoTrackingData:
        '至少选择一条没有跟踪号 且 发货类型是 快递和货代 的数据',
      atLeastOneTrackingData:
        '至少选择一条有跟踪号 且 发货类型是 快递和货代 的数据',
      atLeastOneTrackingData2: '至少选择一条有跟踪号的数据',
      batchUploadTrackingSuccess: '上传中,稍后在平台查看',
      batchAddTrackingSuccess: '批量添加跟踪号成功',
      addTrackingSuccess: '添加跟踪号成功',

      deliveryNotAgentAndExpress: '该发货单号不是货代或快递发货',
      deliverySerialNoNotExist: '该发货单号不存在',
      deliveryHasTracking: '该发货编号已存在跟踪号',
      serialNoHasExist: '该单号已存在',
      serialNoHasExist2: '存在单号已存在的单号',
      deliveryTrackingNotExist: '该跟踪号不存在',
      noShops: '没有店铺',
      finishSuccess: '完成成功',
      remarkFinishSuccess: '标记成功',

      selectDiffCustomer: '选择了不同的客户',
      selectDiffSupplierMaterial: '选择了不同供应商的物料',
      outInvInfoNotExist: '库存不存在该产品',
      selfDeliverySuccess: '自行发货成功',
      confirmReceivePayment: '确认该收款已收',
      differentCurrencies: '存在不同币种的订单',
      fillInValidProductNo: '请输入有效货号',
      updateSuccess: '跟新成功',
      deliveryCheckSuccess: '核对成功',
      //==
      changeFactorySuccess: '转产线成功',
      phaseHasBeenProcess: '该工序已开始生产',
      existProcessedAndFinishedWorkOrder:
        '存在生产完成或者出货结束的工单，不能取消',
      dispatchSuccess: '派单成功',
      distributeSuccess: '派发成功',
      existNoFactoryOrders: '存在没有产线的订单',
      selectDiffFactoryOrders: '选择了不同产线的订单',
      selectFactory: '请先选择产线',
      atLeastOneDataNotPausedAndCancel: '至少选择一条未暂停或者未取消工单',
      atLeastOneDataUnProcessingFinish: '至少选择一条未完成的工单',
      serialNoFinished: '该单号已完成',
      confirmFinish: '确认完成？',
      qaSuccess: '尾查成功',
      atLeastOneDataNoFinish: '至少有一条未结束的记录',
      atLeastOneDataNoHalfCheck: '至少有一条未半检的记录',
      confirmHalfCheckPass: '确认半检通过？',
      atLeastOneWorker: '至少选择一位工人',
      hangCheckedWorkOrder: '请选择正确数量的工单',
      existNoSupplierIdItems: '存在没有供应商的采购单项',
      receiveMatrialSuccess: '收料成功',
      receiveMatrialFinishSuccess: '收料完成成功',
      confirmReceiveMatrialFinish: '确认收料完成?',
      atLeastOneDataUnReceiveMaterial: '至少一条未收料完的数据',
      atLeastOneDataUnFinish: '至少一条未完成的数据',
      receiveMatrialBatchExplain: '说明：默认过滤已收料完成的物料',
      returnMaterialSuccess: '退料成功',
      confirmStorageSuccess: '确认入仓成功',
      ignoreFeedSuccess: '忽略发料成功',
      feedAndDirectFeedSuccess: '发料成功',
      giveSuccess: '发料成功',

      serialNoHasTakeMaterial: '该单号已发料完成',
      feedSuccess: '生成发料单成功',
      afreshMetrialSuccess: '重新配料成功，异步操作，请稍后刷新数据',
      existSettlementedDelivery: '存在结算过的发货单',
      existCourierDiffDelivery: '存在快递公司不同的发货单',
      exitCostIsNull: '存在费用是空的数据',
      changeSuccess: '换料成功',
      batchGiveMaterialExplain: '说明：默认过滤已发过料的数据',
      hasGivedNotBatchGive: '发过料的不能批量发料',
      startSuccess: '开始成功',
      pickSuccess: '出库成功',
      pushSuccess: '入库成功',
      buildPickingListSuccess: '生成捡货清单成功',
      pauseDeliverySuccess: '暂不发货成功',
      adapterImportExplain: '* 时间间隔不能大于24小时',
      unSelectPlatformStore: '没有选择平台店铺',
      hourBeyond24H: '选择的时间大于24小时',
      platformImportSuccess: '导入请求已发送，请稍后到订单列表页中查看',
      taobaoExplain: '*必须进行订购，否则授权无效',
      toHandOverAtExplain: '说明: 订单交货日期 = 当前日期 + 计算交期(天)',
      mergeBargainExplain: '自动合并订单目前仅支持同客户合并',
      clearSuccess: '清除成功',
      clearSubscribeSuccess: '清除订阅成功',
      subscribeSuccess: '订阅成功',
      authorizeSuccess: '授权成功',
      ackLocationsSuccess: '同步信息成功',
      ackAccessTokenSuccess: '获取令牌成功',
      immediateDeliverySuccess: '立即交付成功',
      noSetAgent: '没有设置货代',
      noSetExpress: '没有设置国内快递',
      colorExistVariantMap: '该颜色下存在此替换的物料',
      notManageSubject: '不是管理科目的物料',
      existBeyondInvQty: '存在数量大于库存数量的数据',
      productNotExist: '该货号不存在',
      retrieveSuccess: '撤单成功',
      changeSuccess: '转单成功',
      reDeliverySuccess: '重发成功',
      scanDeliveryUpdateSerialNo: '数据已加载', // 更新该单号
      existUnMixRecords: '存在未配料的记录',
      adjustInventoryShelfSuccess: '调整库存成功',
      manualAuthSuccess: '手动授权成功',
      showSuccess: '上架成功',
      cancelShowSuccess: '下架成功',
      atLeastOneDataCanBatchAcceptRecords:
        '至少选择一条受理仓是我管理的可受理的调拨单',
      ignoreSuccess: '忽略成功',
      mainProductsPrompt: '建议每张图片宽高比1:1.5',
      copySuccess: '复制成功',
      upgradeToMemberSuccess: '转会员成功',
      dispatchPackageNumber: '分包数量不能大与于当前订单数量',
      settlementSuccess: '结账成功',
      virtualCreateProduceSucess: '标记采购单生成日期成功',
      sellerShip: '发货通知成功',
      asynchronousAction: '异步操作，稍后刷新后查询',
      exchangePrompt: '单位换算比：例如1包等于60颗，即换算比是60',
      copyScheduleSuccess: '复制产能假期成功',
      autoScheduleSuccess: '智能排程成功',
      sendSuccess: '发送成功',
      noSetCapacity: '产线未设置产能',
      addAddressSuccess: '新增地址成功',
      editAddressSuccess: '编辑地址成功',
      dispatchBeyondSchedule:
        '存在超出产线的最大产能的订单,若继续派单工单不能进行智能排程',
      dispatchBeyondSchedule2:
        '存在超出产线的最大产能的包,若继续派单工单不能进行智能排程',
      groupSuccess: '分组成功',
      reProcessingSuccess: '恢复生产成功',
      integrationSuccess: '集成成功',
      onlineDeclarationSuccess: '申报成功',
      atLeastOneDataTrackingBargain: '至少选择一条有跟踪号的订单',
      preDeliverSuccess: '揽收成功',
      dhlDpsProdSuccess: '开通正式申报成功',
      setNoticeUrlSuccess: '设置抛送地址成功',
    },
    placeholder: {
      namePhone: '姓名 账号',
      workersNameSerialNo: '姓名 工号',
      serialNoInnerSerialNoCustomer: '单号 内部单号 客户',
      serialNoCustomer: '单号 客户',
      serialNoInnerSerialNo: '单号 内部单号',
      productNoCustomerProductNo: '货号 客户货号',
      serialNoCustomer: '单号 客户',
      serialNoRemark: '单号 备注',
      customerNameCompanyPhone: '名字 公司名 手机号',
      serialNoCustomerNamePhone: '退货单号 客户名称 电话',
      deliverySerialNoTrackingReturnTracking: '原发货单号 跟踪号 退货跟踪号',
      expressChannel: '快递公司 渠道',
    },
    tabs: {
      oneMonth: '近一个月',
      all: '全部',
    },
    action: {
      distributeCustomer: '分配客户',
      synMes: '同步到生产',
      clearMapping: '清除映射',
      printInvoice: '打印发票',
      cancelTracking: '取消运单号',
      sendVfcode: '发送验证码',
      editName: '编辑姓名',
      editPassword: '修改密码',
      resetPassword: '重置密码',
      setInvalid: '设置失效',
      authorize: '授权',
      authData: '数据授权',
      authAction: '操作授权',
      auth: '权限',
      // updateAuth: '编辑权限',
      setShelf: '设置库位',
      setStatistic: '设置统计货币',
      print: '打印',
      printWorker: '打印工牌',
      deliverMethods: '发货渠道',
      printQrCode: '打印二维码',
      printProcessList: '打印生产单',
      printList: '打印列表',
      printListByAssociateSerialNo: '根据相关单号打印',
      printEOrder: '打印面单',
      printHandoverList: '打印交接单',
      printDetailList: '打印清单',
      printChecked: '勾选打印',
      printSearch: '搜索打印',
      download: '下载',
      downLoadChecked: '勾选下载',
      downLoadSearch: '搜索下载',
      downLoadCheckedWithImg: '勾选下载(带图片)',
      downLoadSearchWithImg: '搜索下载(带图片)',
      downloadAddress: '下载地址',
      downLoadMiddlePost: '中邮小包',
      downLoadEPost: 'E邮宝',
      downloadAttatchment: '下载附件',
      autoScheduleChecked: '勾选工单(需同一产线)',
      autoScheduleSearch: '搜索工单(先选择产线)',

      refresh: '刷新',
      inquiry: '询价',
      checkAll: '全选',
      setDefaultSupplier: '设置默认供应商',
      verify: '审核',

      selfVerify: '核对通过',
      selfMarkError: '核对问题',
      clearSelfMarkError: '核对问题消除',
      otherVerify: '对帐通过',
      markError: '对账问题',
      clearMarkError: '对账问题消除',

      settlementCheck: '核对',
      receivePaymentOff: '收款完毕',
      paymentOff: '付款完毕',

      asyncImageToOrder: '同步图片至订单',
      asyncImageToInv: '同步图片至库存',
      importVariantMap: '导入换料映射',
      import: '导入',
      manualImport: '手动导入',

      ingredientFinish: '配料完成',
      printPriductMaterial: '打印配料表',
      linkImage: '图片链接',
      printTag: '打印吊牌',
      productAsyncInv: '货号已修改，是否同步库存',
      confirmAsyncInv: '确认同步库存',
      importIngredient: '导入配料',
      importPhases: '导入工序',
      importPayment: '导入收款',
      importAmazon: '亚马逊导入',
      privatize: '转化成我的',
      batchDiscount: '批量折扣',
      stockIn: '入库',
      stockOut: '出库',
      damage: '报损',
      rework: '返工',
      allocateOut: '申请调出',
      allocateIn: '申请调入',
      manualLockQuantity: '手动锁定库存',
      adjustInventoryShelf: '手动调整库位',
      allocateApplayIn: '申请要货',
      inventoryCheck: '库存盘点',
      check: '盘点',
      importInventory: '盘点导入',
      addProduct: '添加产品',
      exportAll: '库存快照',
      accept: '受理',
      reject: '拒绝',
      printList1: '列表打印1',
      printList2: '列表打印2',
      agree: '同意',
      distributiveOwner: '分配拥有人',
      customersOrders: '查看订单',
      customersBalance: '充值消费记录',
      recharge: '账户充值',
      rechargeScore: '积分',
      flag: '标旗帜',
      confirmBargain: '确认订单',
      paymentCompleted: '收款完毕',
      addGroup: '加入分组',
      mergeBargain: '合并订单',
      payment: '收款',
      paymentPay: '付款',
      paymentReceive: '收款',
      submitAndConfirm: '提交并确认',
      addPayment: '添加收款',
      addReceiveAndPayment: '收款/退款',
      paymentReturn: '退款',
      paymentIgnore: '抹零',
      distributiveOwner: '分配拥有人',
      editAddress: '编辑地址',
      editBargainHurry: '订单项加急',
      editHandOverAt: '编辑交期',
      copy: '复制',
      printSaleOrder: '打印销售单',
      printSaleOrderWhole: '完整销售单',
      printSaleOrderSimple: '精简销售单',
      printByProductNoColor: '订单汇总表',
      confirmOrder: '确认订单',
      cancelConfirmOrder: '取消确认',
      retriveToPenging: '撤回待处理',
      changeSpec: '改码出库',
      downloadProcessList: '下载生产单',
      reminder: '催单',
      place: '下单',
      signSettle: '标记结算',
      retrive: '撤单',
      viewPurchaseHistory: '外采历史',
      remake: '改制',
      hang: '挂单',
      addProducts: '添加产品',

      receiveAndQuality: '收货并质检通过',
      receiveChangeSize: '改码收货',
      receiveAndScan: '收货/扫描收货',
      scanReceive: '扫描收货',
      quality: '质检通过',
      qualityAndPush: '质检并入库',
      qualityAndDelivery: '质检并发货',
      printPickingList: '打印出库单',
      printA4: 'A4打印',
      pringTP: '热敏打印',
      deliver: '发货',
      deliverAndPrintEOrder: '发货并打印面单',
      printDelivery: '打印发货单',
      printDelivery2: '打印出货单',
      pickingList: '出库单',
      pickShelf: '出库',
      pushShelf: '入库',
      pickShelf2: '拣货',
      batchAddTracking: '批量添加跟踪号',
      addTracking: '添加跟踪号',
      batchUploadTracking: '上传跟踪号',
      loopDelivery: '循环自行发货/称重',
      loopWeight: '循环称重',
      pickingCheck: '发货校验',
      selfDelivery: '自行发货',
      signSettle: '标记结算',
      cancelSignSettle: '取消标记结算',
      finishDone: '完成',
      finishGiveUp: '放弃',
      addFollow: '添加跟踪',
      printRent: '打印租赁单',
      printClean: '打印清洗单',
      deliveryRequisitions: '发货申请',
      deliveryBeforehand: '预发货',
      financeVerifyCancel: '反审核',
      buildPickingList: '生成捡货清单',
      debtDeliveryVerify: '发货审核',
      know: '知道了',
      dealed: '已处理',
      selectSupplier: '选择供应商',
      selectFactory: '选择产线',
      selectShelf: '选择库位',
      synchronize: '同步',
      pause: '暂停生产',
      reManufacture: '恢复生产',
      reDispatch: '重新派单',
      retrieve: '撤单',
      editWorkOrderSn: '编辑工单号',
      intelligentDispatch: '智能派单',
      handmadeDispatch: '手工派单',
      branchIntelligentDispatch: '智能分包派单',
      branchHandmadeDispatch: '手工分包派单',

      editRemark: '编辑备注',
      dispatch: '派发',
      processingFinish: '生产完成',
      finish: '完成',
      markFinish: '标记完成',
      receive: '收货',
      receiveAndQuality: '收货并质检',
      receiveAndQualityAndPush: '收货并入库',
      receiveAndQualityAndDelivery: '收货并发货',
      receive2: '接收',
      qa: '尾查',
      finishPhase: '结束工序',
      halfCheckPass: '半检通过',
      editHour: '编辑工时',
      deal: '处理',
      addMaterial: '添加物料',
      applyPurchase: '生成采购单',
      createProcureChecked: '勾选生成采购单',
      createProcureSearch: '搜索生成采购单',
      receiveMatrial: '收料',
      receiveMatrialFinish: '标记收料完成',
      addProcureItem: '新增采购单项',
      confirmStorage: '确认入仓',
      returnMaterial: '退料',
      ignoreFeed: '忽略发料',
      feed: '生成发料单',
      feedAndDirectFeed: '生成发料单并发料',
      afreshMetrial: '重新获取配料',
      give: '发料',
      importCheck: '导入对账',
      changeMaterial: '换料',
      setCategory: '设置分类',
      addMore: '添加更多',

      order1: '订购1',
      authorize2: '授权2',
      subscribe3: '订阅3',
      cancelSubscribe: '取消订阅',
      authorize: '授权',
      agreeAuthorize: '同意授权',
      authorize1: '授权1',
      subscribe2: '订阅2',
      manualAuth: '手动授权',
      ackLocations3: '信息同步3',
      ackAccessToken2: '获取令牌2',
      clearSubscribe: '清除订阅',
      setNoticeUrl: '设置抛送地址',
      synSupplierPrice: '同步价格到其他产品',
      immediateDelivery: '立即交付',
      inventorySearchSchedule: '租赁查档期',
      adapterImport: '执行导入',
      share: '共享',
      materialSearch: '询料',
      change: '转单',
      reDelivery: '重发',
      asyncPhaseToPdm: '工序同步到产品中心',
      asyncMaterialToPdm: '物料同步到产品中心',
      group: '分组',
      show: '上架',
      cancelShow: '下架',
      recovery: '恢复',
      markFinishAt: '标记完成',
      ignore: '忽略',
      importCourierCost: '导入费用',
      importTracking: '导入跟踪号',
      lianbang: '联邦快递官方对接',
      addressAnalysis: '地址解析',
      upgradeToMember: '转会员',
      intelligentCheck: '智能对帐',
      reportMonthSettlement: '月度结账',
      supplierSettlementCount: '欠款汇总',
      virtualCreateProduce: '标记生成采购单',

      printBaseInfo: '打印基本信息',
      refreshTracking: '重新获取跟踪号',
      sellerShip: '发货通知',
      batchAsyncProcessing: '同步到生产管理',
      editScheduleAt: '编辑开工日期',
      copySchedule: '复制能休假期',
      autoSchedule: '智能排程',
      searchMesSchedule: '询产能',
      calcExpectHandOver: '排产预测',
      sendMessage: '发消息',
      select: '选择',
      knockInv: '别名撞库',
      clearSpecJson: '清空值',
      addAddress: '新增地址',
      editAddress: '编辑地址',
      selectOtherAddress: '更换其他地址',
      updateSupplierPriceToCostSimple: '更新成本价',
      updateSupplierPriceToCost: '确定默认供应商价格更新到成本价？',
      updateChecked: '勾选更新',
      updateSearch: '搜索更新',
      scanRecords: '扫描记录',
      cashReStore: '退仓',
      reProcessing: '恢复生产',
      printPck: '打印拣货单',
      cancelPrintPck: '取消打印拣货单',
      integration: '集成',
      onlineDeclaration: '在线申报',
      updateHsInfo: '设置海关属性',
      applyTracking: '申请运单号',
      collectDelivery: '揽收',
      updateCpCode: '编辑物流编码',
      dhlDpsProd: '开通正式申报',
      batchSetHandCycle: '按科目设置货期',
      batchSetHandCycleBySupplier: '按供应商设置货期',
    },
    entityTypes: {
      order: '订单',
      workOrder: '工单',
    },
    scanRecord: {
      scanName: '扫描人',
      scanAt: '扫描日期',
      entityType: '实体类型',
    },
    reworkTypes: {
      inventory: '库存返工',
      purchase: '外采返工',
      manufacture: '生产返工',
      returnBack: '退货返工',
      // availableOQC: '出货质检返工',
      // orderRework: '',
      //
      mesQuality: '尾查返工',
      core: '退厂返工',
    },
    receive: {
      remark: '收货备注',
      qualityInfo: '质检情况',
      qualitier: '质检人',
      qualityAt: '质检日期',
      receiver: '收货人',
      receivedQuantity: '已收货数量',
      qualityQuantity: '质检数量',
      reworkQuantity: '返工数量',
      storageName: '入仓人',
      storageQuantity: '入仓数量',
      pengingQualityQuantity: '待质检数量',
      pengingStackQuantity: '待入库数量',
      stackQuantity: '已入库数量',
      shelfQuantity: '入库量',
      receiveInfo: '收货情况',
      isQuality: '是否需要质检(是:需要到待质检质检入仓)',
      receiveWarehouseVirtual: '拟入仓',
      receiveWarehouse: '收入仓',
      receiveAt: '收料日期',
      receivedQuantityMms: '可用数量',
      qualityQuantityMms: '可用数量',
      returnAtMms: '退料日期',
      storageAtMms: '确认入仓日期',
      storageNo: '未确认入仓',
    },

    qualityInfos: {
      yes: '已质检',
      no: '未质检',
    },
    qualityInfosMms: {
      unQuality: '未质检',
      qualityPass: '质检通过',
      qualityReturn: '退料',
      notNeedQuality: '勿须质检',
    },
    receiveInfos: {
      yes: '已收货',
      no: '未收货',
    },
    reminder: {
      remark: '催单备注',
      readAt: '阅读时间',
      createAt: '催单日期',
    },
    event: {
      handleAt: '处理时间',
      content: '内容',
    },
    eventStates: {
      unHandle: '未处理',
      handled: '已处理',
    },
    // // storageInfos: {
    // //   stockIn: '已入库',
    // //   unStockIn: '未入库'
    // // },
    receiveTypes: {
      purchaseReceive: '外采',
      purchaseChangeSpecsReceive: '外采改码',
      purchaseForceReceive: '外采强制',
      purchaseChangeSpecsForceReceive: '外采改码强制',
      purchaseRework: '外采返工',
      inventoryRework: '库存返工',
      returnBack: '退货',
      returnBackRework: '退货返工',
      //
      manufactureReceive: '生产',
      manufactureRework: '生产返工',
      manufactureForceReceive: '生产强制',

      availableOQC: '现货出货',
      availableOQCRework: '现货出货返工完成',
    },
    platform: {
      name: '名称',
      prefix: '订单号前缀',
      storeOwnerId: '店铺负责人',
      toHandOverAt: '计算交期(天)',
      shop: '导入店铺',
      percent: '扣除百分比(%)',
      importOrder: '自动导入订单',
      accessToken: '授权情况',
      authTokenAt: '授权日期',
      siteId: '站点',
      region: '地区',
      sellerId: '卖家编号',
      marketplaceid: '市场编号',
      authToken: '令牌',
      storeUrl: '网址',
      day: '天',
      asyncTrack: '上传跟踪号',
      importColor: '导入颜色',
      importSize: '导入规格',
      mergeBargain: '自动合并订单',
      // accessToken: "授权情况",
      subscribeAt: '订阅日期',
      importTax: '导入税费',
      tbUserId: '店铺id',
      toHandOverAt: '交期提前天数',
      cpCode: '物流编码',
      notifyUrl: 'URL',
    },
    accessTokens: {
      true: '已授权',
      false: '未授权',
    },

    scanReceiveTypes: {
      receive: '正常收货',
      purchaseUnDeliver: '供应商未发货',
      workerOrderUnFinish: '工厂未生产完成',
      orderUnFinish: '未生产完成',
    },
    countries: {
      CN: 'China(中国)',
      AD: 'Andorra(安道尔)',
      AE: 'United Arab Emirates(阿拉伯联合酋长国)',
      AF: 'Afghanistan(阿富汗)',
      AG: 'Antigua and Barbuda(安提瓜和巴布达)',
      AI: 'Anguilla(安圭拉岛)',
      AL: 'Albania(阿尔巴尼亚)',
      AM: 'Armenia(亚美尼亚)',
      AN: 'Netherlands Antilles(荷属安的列斯群岛)',
      AO: 'Angola(安哥拉)',
      AQ: 'Antarctica(南极洲)',
      AR: 'Argentina(阿根廷)',
      AS: 'American Samoa(美属萨摩亚)',
      AT: 'Austria(奥地利)',
      AU: 'Australia(澳大利亚)',
      AW: 'Aruba(阿鲁巴岛)',
      AX: 'Aland Islands(奥兰群岛)',
      AZ: 'Azerbaijan(阿塞拜疆)',
      BA: 'Bosnia and Herzegovina(波黑)',
      BB: 'Barbados(巴巴多斯岛)',
      BD: 'Bangladesh(孟加拉共和国)',
      BE: 'Belgium(比利时)',
      BF: 'Burkina Faso(布基纳法索)',
      BG: 'Bulgaria(保加利亚)',
      BH: 'Bahrain(巴林)',
      BI: 'Burundi(布隆迪)',
      BJ: 'Benin(贝宁湾)',
      BL: 'Saint Barthélemy(圣巴茨岛)',
      BM: 'Bermuda(百慕大群岛)',
      BN: 'Brunei(文莱)',
      BO: 'Bolivia(玻利维亚)',
      BQ: 'British Antarctic Territory(英属南极领地)',
      BR: 'Brazil(巴西)',
      BS: 'Bahamas(巴哈马群岛)',
      BT: 'Bhutan(不丹)',
      BV: 'Bouvet Island(布韦岛)',
      BW: 'Botswana(博茨瓦纳)',
      BY: 'Belarus(白俄罗斯)',
      BZ: 'Belize(伯利兹)',
      CA: 'Canada(加拿大)',
      CC: 'Cocos Islands(科科斯群岛)',
      CD: 'Congo - Kinshasa(刚果（金）)',
      CF: 'Central African Republic(中非共和国)',
      CG: 'Congo - Brazzaville(刚果布)',
      CH: 'Switzerland(瑞士)',
      CI: "Cote d'Ivoire(科特迪瓦)",
      CK: 'Cook Islands(库克群岛)',
      CL: 'Chile(智利)',
      CM: 'Cameroon(喀麦隆)',
      CO: 'Colombia(哥伦比亚)',
      CR: 'Costa Rica(哥斯达黎加)',
      CS: 'Serbia and Montenegro(塞尔维亚和黑山)',
      CT: 'Canton and Enderbury Islands(广州和利群岛)',
      CU: 'Cuba(古巴)',
      CV: 'Cape Verde(佛得角)',
      CX: 'Christmas Island(圣诞岛)',
      CY: 'Cyprus(塞浦路斯)',
      CZ: 'Czech Republic(捷克)',
      DD: 'East Germany(东德)',
      DE: 'Germany(德国)',
      DJ: 'Djibouti(吉布提)',
      DK: 'Denmark(丹麦)',
      DM: 'Dominica(多米尼加)',
      DO: 'Dominican Republic(多米尼加共和国)',
      DZ: 'Algeria(阿尔及利亚)',
      EC: 'Ecuador(厄瓜多尔)',
      EE: 'Estonia(爱沙尼亚)',
      EG: 'Egypt(埃及)',
      EH: 'Western Sahara(西撒哈拉)',
      ER: 'Eritrea(厄立特里亚)',
      ES: 'Spain(西班牙)',
      ET: 'Ethiopia(埃塞俄比亚)',
      FI: 'Finland(芬兰)',
      FJ: 'Fiji(斐济)',
      FK: 'Falkland Islands(福克兰群岛)',
      FM: 'Micronesia(密克罗尼西亚)',
      FO: 'Faroe Islands(法罗群岛)',
      FQ: 'French Southern and Antarctic Territories(法国南方和南极领地)',
      FR: 'France(法国)',
      FX: 'Metropolitan France(法国本土)',
      GA: 'Gabon(加蓬)',
      GB: 'United Kingdom(UK)(英国)',
      GD: 'Grenada(格林纳达)',
      GE: 'Georgia(格鲁吉亚)',
      GF: 'French Guiana(法属圭亚那)',
      GG: 'Guernsey(根西岛)',
      GH: 'Ghana(加纳)',
      GI: 'Gibraltar(直布罗陀)',
      GL: 'Greenland(格陵兰)',
      GM: 'Gambia(冈比亚)',
      GN: 'Guinea(几内亚)',
      GP: 'Guadeloupe(瓜德罗普岛)',
      GQ: 'Equatorial Guinea(赤道几内亚)',
      GR: 'Greece(希腊)',
      GS: 'South Georgia and the South Sandwich Islands(南乔治亚岛与南桑威奇群岛)',
      GT: 'Guatemala(危地马拉)',
      GU: 'Guam(关岛)',
      GW: 'Guinea-Bissau(几内亚比绍共和国)',
      GY: 'Guyana(圭亚那)',
      HK: 'Hong Kong(中国香港特别行政区)',
      HM: 'Heard Island and McDonald Islands(赫德岛和麦克唐纳岛)',
      HN: 'Honduras(洪都拉斯)',
      HR: 'Croatia(克罗地亚)',
      HT: 'Haiti(海地)',
      HU: 'Hungary(匈牙利)',
      ID: 'Indonesia(印尼)',
      IE: 'Ireland(爱尔兰)',
      IL: 'Israel(以色列)',
      IM: 'Isle of Man(马恩岛)',
      IN: 'India(印度)',
      IO: 'British Indian Ocean Territory(英属印度洋领地)',
      IQ: 'Iraq(伊拉克共和国)',
      IR: 'Iran(伊朗)',
      IS: 'Iceland(冰岛)',
      IT: 'Italy(意大利)',
      JE: 'Jersey(泽西岛)',
      JM: 'Jamaica(牙买加)',
      JO: 'Jordan(约旦)',
      JP: 'Japan(日本)',
      JT: 'Johnston Island(约翰斯顿岛)',
      KE: 'Kenya(肯尼亚)',
      KG: 'Kyrgyzstan(吉尔吉斯斯坦)',
      KH: 'Cambodia(柬埔寨)',
      KI: 'Kiribati(基里巴斯)',
      KM: 'Comoros(科摩罗)',
      KN: 'Saint Kitts and Nevis(圣克里斯托弗和尼维斯岛)',
      KP: 'North Korea(朝鲜)',
      KR: 'South Korea(韩国)',
      KW: 'Kuwait(科威特)',
      KY: 'Cayman Islands(开曼群岛)',
      KZ: 'Kazakhstan(哈萨克斯坦)',
      LA: 'Laos(老挝国)',
      LB: 'Lebanon(黎巴嫩)',
      LC: 'Saint Lucia(圣卢西亚岛)',
      LI: 'Liechtenstein(列支敦斯登)',
      LK: 'Sri Lanka(斯里兰卡)',
      LR: 'Liberia(利比里亚)',
      LS: 'Lesotho(莱索托)',
      LT: 'Lithuania(立陶宛)',
      LU: 'Luxembourg(卢森堡)',
      LV: 'Latvia(拉脱维亚)',
      LY: 'Libya(利比亚)',
      MA: 'Morocco(摩洛哥)',
      MC: 'Monaco(摩纳哥)',
      MD: 'Moldova(摩尔多瓦)',
      ME: 'Montenegro(黑山共和国)',
      MF: 'Saint Martin(圣马丁岛)',
      MG: 'Madagascar(马达加斯加岛)',
      MH: 'Marshall Islands(马绍尔群岛)',
      MI: 'Midway Islands(中途岛)',
      MK: 'Macedonia(马其顿)',
      ML: 'Mali(马里)',
      MM: 'Myanmar(缅甸)',
      MN: 'Mongolia(蒙古)',
      MO: 'Macau(中国澳门特别行政区)',
      MP: 'Northern Mariana Islands(北马里亚纳群岛)',
      MQ: 'Martinique(马提尼克岛)',
      MR: 'Mauritania(毛利塔尼亚)',
      MS: 'Montserrat(蒙特塞拉特岛)',
      MT: 'Malta(马耳他)',
      MU: 'Mauritius(毛里求斯)',
      MV: 'Maldives(马尔代夫)',
      MW: 'Malawi(马拉维)',
      MX: 'Mexico(墨西哥)',
      MY: 'Malaysia(马来西亚)',
      MZ: 'Mozambique(莫桑比克)',
      NA: 'Namibia(纳米比亚)',
      NC: 'New Caledonia(新喀里多尼亚)',
      NE: 'Niger(尼日尔)',
      NF: 'Norfolk Island(诺福克岛)',
      NG: 'Nigeria(尼日利亚)',
      NI: 'Nicaragua(尼加拉瓜)',
      NL: 'Netherlands(荷兰)',
      NO: 'Norway(挪威)',
      NP: 'Nepal(尼泊尔)',
      NQ: 'Dronning Maud Land(毛德皇后地)',
      NR: 'Nauru(瑙鲁)',
      NT: 'Neutral Zone(中立区)',
      NU: 'Niue(纽埃岛)',
      NZ: 'New Zealand(新西兰)',
      OM: 'Oman(阿曼)',
      PA: 'Panama(巴拿马)',
      PC: 'Pacific Islands Trust Territory(太平洋岛屿托管领土)',
      PE: 'Peru(秘鲁)',
      PF: 'French Polynesia(法属玻利尼西亚)',
      PG: 'Papua New Guinea(巴布亚新几内亚)',
      PH: 'Philippines(菲律宾)',
      PK: 'Pakistan(巴基斯坦)',
      PL: 'Poland(波兰)',
      PM: 'Saint Pierre and Miquelon(圣皮埃尔和密克隆)',
      PN: 'Pitcairn(皮特克恩岛)',
      PR: 'Puerto Rico(波多黎各)',
      PS: 'Palestinian Territory(巴勒斯坦领土)',
      PT: 'Portugal(葡萄牙)',
      PU: 'U.S. Miscellaneous Pacific Islands(美控太平洋岛屿)',
      PW: 'Palau(帕劳群岛)',
      PY: 'Paraguay(巴拉圭)',
      PZ: 'Panama Canal Zone(巴拿马运河区)',
      QA: 'Qatar(卡塔尔)',
      QO: 'Outlying Oceania(边远的大洋洲)',
      QU: 'European Union(欧洲联盟)',
      RE: 'Reunion(留尼旺岛)',
      RO: 'Romania(罗马尼亚)',
      RS: 'Serbia(塞尔维亚)',
      RU: 'Russian Federation(俄罗斯)',
      RW: 'Rwanda(卢旺达)',
      SA: 'Saudi Arabia(沙特阿拉伯)',
      SB: 'Solomon Islands(所罗门群岛)',
      SC: 'Seychelles(塞舌尔)',
      SD: 'Sudan(苏丹)',
      SE: 'Sweden(瑞典)',
      SG: 'Singapore(新加坡)',
      SH: 'Saint Helena(圣赫勒拿岛)',
      SI: 'Slovenia(斯洛文尼亚)',
      SJ: 'Svalbard and Jan Mayen(斯瓦尔巴岛和扬马延岛)',
      SK: 'Slovakia(斯洛伐克)',
      SL: 'Sierra Leone(塞拉利昂)',
      SM: 'San Marino(圣马力诺)',
      SN: 'Senegal(塞内加尔)',
      SO: 'Somalia(索马里)',
      SR: 'Suriname(苏里南)',
      ST: 'Sao Tome and Principe(圣多美和普林西比)',
      SU: 'Union of Soviet Socialist Republics(苏联)',
      SV: 'El Salvador(萨尔瓦多)',
      SY: 'Syria(叙利亚)',
      SZ: 'Swaziland(斯威士兰)',
      TC: 'Turks and Caicos Islands(特克斯和凯科斯群岛)',
      TD: 'Chad(乍得湖)',
      TF: 'French Southern Territories(法属南半球领地)',
      TG: 'Togo(多哥)',
      TH: 'Thailand(泰国)',
      TJ: 'Tajikistan(塔吉克斯坦)',
      TK: 'Tokelau(托克劳群岛)',
      TL: 'East Timor(东帝汶)',
      TM: 'Turkmenistan(土库曼斯坦)',
      TN: 'Tunisia(突尼斯)',
      TO: 'Tonga(汤加)',
      TR: 'Turkey(土耳其)',
      TT: 'Trinidad and Tobago(特立尼达和多巴哥)',
      TV: 'Tuvalu(图瓦卢)',
      TW: 'Taiwan(中国台湾地区)',
      TZ: 'Tanzania(坦桑尼亚)',
      UA: 'Ukraine(乌克兰)',
      UG: 'Uganda(乌干达)',
      UM: 'United States Minor Outlying Islands(美国本土外小岛屿)',
      US: 'United States(美国)',
      UY: 'Uruguay(乌拉圭)',
      UZ: 'Uzbekistan(乌兹别克斯坦)',
      VA: 'Vatican(梵蒂冈)',
      VC: 'Saint Vincent and the Grenadines(圣文森特和格林纳丁斯)',
      VD: 'North Vietnam(北越)',
      VE: 'Venezuela(委内瑞拉)',
      VG: 'British Virgin Islands(英属维京群岛)',
      VI: 'U.S. Virgin Islands(美属维尔京群岛)',
      VN: 'Vietnam(越南)',
      VU: 'Vanuatu(瓦努阿图)',
      WF: 'Wallis and Futuna(瓦利斯群岛和富图纳群岛)',
      WK: 'Wake Island(威克岛)',
      WS: 'Samoa(萨摩亚群岛)',
      YD: "People's Democratic Republic of Yemen(也门人民民主共和国)",
      YE: 'Yemen(也门)',
      YT: 'Mayotte(马约特岛)',
      ZA: 'South Africa(南非)',
      ZM: 'Zambia(赞比亚)',
      ZW: 'Zimbabwe(津巴布韦)',
      YK: 'Kosovo(科索沃)',
      RA: 'Remote area of us(美国偏远地区)',
    },
  },
};
